import Vue from 'vue';
import Vuex from 'vuex';
import { vuexSimple, range, loadForage, setDefaults, licensePlate } from '@/helpers';
import videosNS from '@/store/videos';
import tweetsNS from '@/store/tweets';
import documentsNS from '@/store/documents';
import insights from '@/store/insights';
import VueCookie from 'vue-cookie';
// import VuexPersistence from 'vuex-persist';
// import localJSON from '@/store/local';
// import localJSON from '@/store/localgs';
const localJSON = null;
// import VuexPersistence from 'vuex-persist'
Vue.use(Vuex);
Vue.use(VueCookie);
const awsBase = 'https://s3-us-west-2.amazonaws.com/weave.ai/topo/scenes/';
let clearLoaderTimer;
let pdfTimer;
// const lpServer = /localhost\:80/.exec(location.href) && 'http://localhost:3000' || 'https://weave-qa.qrl.sh';
// const lpServer = /localhost\:80/.exec(location.href) && 'http://localhost:8003' || 'https://weave.qrl.sh';
const lpServer = 'https://weave-qa.qrl.sh';
// const lpServer = 'https://weave-sfo.qrl.sh';
// const sockServer = /localhost\:80/.exec(location.href) && 'http://localhost:8003/emission' || 'https://weave-connect.qrl.sh/emission';
console.log('lp', lpServer);
const sockServer = 'https://weave-connect.qrl.sh/emission';
const logoBase = 'https://d2ddtbv4exdam1.cloudfront.net/cs/logos/';
const lens = /localhost\:81|\blens\b|\bengage[0-9]?\b|\breader\b|\btmp\b|\bengage\b|\brw\b|\bd1lc8\b|\bregeneron\b|\btrial\b|\bpdf\b|\bspectrum\b/.test(location.href);
export default store();
const roboReportFetches = [];
const engageRoboReportFetches = [];
async function store() {
  if (!store.instance) {
    const insightsNS = await insights;
    //const props = { collection: (sceneTable || 'collections' || []) };
    const props = {
      zoomLevel: 1,
      lazyLevel: 100,
      shown: false,
      cloud: false,
      videosShown: false,
      tweetsShown: false,
      documentsShown: false,
      selectedTags: {},
      maxTweets: 4,
      //categories,
      scenes: null,
      playlist: null,
      player: null,
      playing: false,
      collapsed: true,
      videos: null,
      tweets: null,
      documents: null,
      selectedDocuments: {},
      query: '',
      topos: {},
      searchFocus: false,
      persistedSelection: [],
      currentVideo: null,
      currentDocument: null,
      currentPage: null,
      bigViewerShown: false,
      documentThumbsOnly: false,
      facetsCollapsed: Vue.cookie.get('facetsCollapsed') === 'true',
      title: '',
      doco: '',
      sort: '',
      default_sort: 'ascending',
      docSort: 'ascending',
      aliases: {},
      readingList: [],
      readingListOpen: false,
      readingListIndex: 0,
      dropBefore: null,
      editingReadingList: false,
      license: null,
      licenseUrl: null,
      sharing: false,
      popupOpen: null,
      q: '',
      //inheritUpper: true,
      selector: null,
      inheriter: null,
      selectAll: 'all',
      customSelection: {},
      selectedSectors: [],
      selectedAllTags: {},
      selectedCategories: [],
      sentiment: [0, 6],
      interestingness: [0, 6],
      visuality: [0, 6],
      //default_inheritUpper: null,
      default_sentiment: null,
      default_interestingness: null,
      default_visuality: null,
      selectedToggler: null,
      tickers: null,
      tickersMap: {},
      selectedTickers: {},
      toggleTag: null,
      loader: true,
      forceLoader: true,
      shareClicked: false,
      expandTweets: false,
      pdf: '',
      usePdf: 'a',
      pdfA: '',
      pdfB: '',
      pdfC: '',
      pdfD: '',
      pdfE: '',
      pdfF: '',
      pdfG: '',
      pdfH: '',
      pdfI: '',
      pdfJ: '',
      pdfView: false,
      collapse: Vue.cookie.get('collapse') === 'true',
      andOr: 'or',
      selectedPagesForCheatsheet: {},
      lp: Vue.cookie.get('lp') || '',
      lps:
        (Vue.cookie.get('lps') && JSON.parse(Vue.cookie.get('lps'))) || (await Vue.$localforage.getItem('lps')) || [],
      lpServer,
      sockServer,
      message: null,
      messages: [],
      present: [],
      handle: Vue.cookie.get('handle') || '',
      token: '',
      cheatsheetLP: null,
      cheatsheetJSON: null,
      cheatsheetKeys: null,
      untilSave: 0,
      loadedPages: null,
      loadedDocuments: null,
      loadedTweets: null,
      loadedFeedLps: null,
      loadedFeeds: null,
      loadedTitle: '',
      onClipboard: {},
      copyImage: false,
      docoSmallCache: Object.freeze((await Vue.$localforage.getItem('docoSmallCache')) || {}),
      folderLiteCache: {},
      selectedHeros: (await Vue.$localforage.getItem('selectedHeros')) || {},
      readingListHoveredItem: null,
      clickedFromPages: false,
      compressedInsights: false,
      roomId: 'fun-times',
      connections: [],
      peerjsLoading: true,
      ownId: null,
      peerId: null,
      vidSources: [],
      cheatsheet: [
        /*'qYuCIdiMb0qntC-pKdorXw-2.png|As digital tools become more sophisticated and produce increasingly greater gains, they will take semiconductor companies further into the age of Industry 4.0-a period of greater digitization in the manufacturing sector.',
        'qYuCIdiMb0qntC-pKdorXw-2.png|With insights from a PEA analysis, semiconductor companies can recalibrate the workload and ensure that employees focus on tasks that truly add value.',
        'qYuCIdiMb0qntC-pKdorXw-2.png|They can then implement appropriate digital solutions for these tasks, ensuring even greater gains.',
        'qYuCIdiMb0qntC-pKdorXw-2.png|While better margins are one motivator, companies also want more funds to invest in innovative chips for autonomous vehicles and other emerging technologies.',
        'qYuCIdiMb0qntC-pKdorXw-2.png|So how should semicos gain a greater understanding of their indirect labor?',
        'qYuCIdiMb0qntC-pKdorXw-2.png|And what digital solutions are likely to produce the best results in different functions?',
        'qYuCIdiMb0qntC-pKdorXw-6.png|The company is expected to increase hiring efficiency by 30 to 50 percent and will also improve its return on investment by 400 to 500 percent.',
        'qYuCIdiMb0qntC-pKdorXw-6.png|The company received more than 250,000 résumés per year, and it wanted to reduce screening costs and improve its ability to identify top candidates.',
        'qYuCIdiMb0qntC-pKdorXw-4.png|Advanced analytics, one of the most popular digital solutions, can help tame expenses by identifying the factors contributing to long development timelines and low product quality.',
        'qYuCIdiMb0qntC-pKdorXw-4.png|Since PEA analyses are conducted across functions, they identify solutions that will benefit the organization as a whole, rather than those that help only individual departments.',
        "qYuCIdiMb0qntC-pKdorXw-4.png|When trying to identify the elements of a successful team, the company considered numerous variables, including tenure and the employee's record for design wins."*/
      ],
      editing: false,
      dragging: false,
      dragType: null,
      nudgeChat: {
        top: 0,
        left: 0
      },
      logos: Object.freeze({
        gen1: {
          url: `${ logoBase }genesys-vector-logo.png`,
          transform: 'scale(1.5)'
        },
        gen2: {
          url: `${ logoBase }genesys-tall-logo.png`,
          transform: 'scale(1.5)'
        }
      }),
      logo: null,
      zoomedPages: null,
      zoomedInsights: null,
      zoomedDoc: null,
      plainInsights: false,
      insightsVisible: false,
      docoPublisher: null,
      //themes: null,
      docoThemes: null,
      folderThemes: null,
      roboThemes: null,
      watchlistThemes: null,
      publishers: {},
      folderPublishers: {},
      roboPublishers: {},
      watchlistPublishers: {},
      engagePublishers: {},
      // todo: selectedThemes needs to be distinct for doco, foldr, robo, and watchlist
      selectedThemes: {},
      customThemes: {},
      newTheme: null,
      themesFilter: '',
      lens,
      tocSort: null,
      skimmerSort: null,
      genre: '',
      insightsCache: {},
      insightsRoboCache: {},
      insightsDoco: null,
      insightsShown: null,
      insightsThemesShown: false,
      insightsFilter: '',
      insightsCurrency: false,
      insightsNumeric: false,
      selectedInsightsThemes: {},
      insightsThemesParentFilter: null,
      watchlistThemesShown: false,
      watchlistCurrency: false,
      watchlistNumeric: false,
      watchlistThemesFilter: '',
      watchlistThemeWeightFilter: null,
      watchlistThemeWeightHover: null,
      watchlistNotificationsFilter: '',
      roboNotificationsFilter: '',
      selectedWatchlistThemes: {},
      watchlistThemesAndOr: false,
      selectedWatchlistPublishers: {},
      selectedWatchlistDocTypes: {},
      watchlistThemesRefPub: null,
      watchlistThemesRefPubSwitcher: false,
      watchlistThemesRefPubSwitcherFilter: '',
      watchlistThemesRefPubSentiment: null,
      watchlistThemesRefPubSort: null,
      watchlistThemesHoverRefPubSentiment: null,
      watchListFeedCategories: null,
      watchListSelectedFeedCategories: {},
      watchlistDocTypes: {
        wt: 'Webcast transcripts',
        ect: 'Earnings call transcripts',
        iann: 'Investor announcements',
        '10q': 'SEC filings',
        esgrp: 'ESG reports',
        ar: 'Annual reports',
        ipr: 'Investor presentations',
        csrrp: 'CSR reports',
        esgud: 'ESG updates'
      },
      watchlistCustomActions: null,
      watchlistHideESG: false,
      watchlistHideAnalytics: false,
      watchlistThemesParentFilter: null,
      industry: null,
      primaryThemeConcept: null,
      copyUrls: false,
      skimmerShown: false,
      roboShown: false,
      roboText: '',
      submittedRoboText: null,
      roboFetching: false,
      docoInsights: [],
      docoJSON: null,
      insightsSentiment: [0, 6],
      default_insightsSentiment: null,
      folderList: null,
      folderDoco: null,
      robo: null,
      roboWeaveShown: null,
      roboWeaveTitle: null,
      watchlistTitle: null,
      roboFolder: null,
      folderPreviewsShown: false,
      notificationsShown: true,
      notificationFilter: null,
      folderAge: [0, 10],
      default_folderAge: null,
      trending: null,
      tweetFeeds: null,
      videoFeeds: null,
      feeds: null,
      backToRobo: null,
      analytics: null,
      folderAnalytics: null,
      chartShown: false,
      hoverKey: null,
      hoverTime: null,
      hoverPub: null,
      hoverTheme: null,
      selectedVis: null,
      referencePub: null,
      refPubInfoShown: false,
      refPubInfoNudge: { top : 0, left: 0},
      leadingTrailing: false,
      insightsCloudShown: false,
      selectedParentTheme: null,
      // todo: generalize
      folderZoomedDoc: {},
      watchlist: {},
      watchlistShown: false,
      backToWatchlist: false,
      watchlistAnalytics: {},
      watchlistFeeds: null,
      watchlistTrending: null,
      watchlistNotificationFilter: null,
      //make dynamic
      roboReportStartTime: '14.4',
      roboReportEndTime: '21.2',
      roboReportShown: false,
      roboReportMinimized: false,
      roboReportLaunchedFromWatchList: false,
      roboReportThemesSize: 10,
      roboReport: null,
      defaultRoboReportUrl: null,
      loadingImages: {},
      parentThemesTable: {},
      engage: null,
      spotlight: null,
      engageShown: false,
      engageViewMode: 'abc',
      engagePlaying: false,
      engageReportCardShown: false,
      engageSelectedSection: null,
      engageLastSelectedSection: null,
      engageRoboReport: null,
      defaultEngageRoboReportUrl: null,
      engageSelectedDocuments: {},
      engageSelectedPublishers: {},
      engageOnlyLastQuarter: true,
      engageMaxAge: 'last quarter',
      engageTocPageCount: null,
      engageSelectedThemes: {},
      engageKeywords: '',
      engageLinksShown: false,
      pdfPending: false,
      styleFilter: null,
      engageShowPubBadges: false,
      dividendOnly: false,
      engageNewOnly: false,
      engageSelectedRegions: {},
      engageSelectedSectors: {},
      engagePub: null,
      engagePubContext: {},
      engageStockOverview: {},
      engageFullHoldings: null,
      engageFundGrowthRate: null,
      engageNotificationsShown: false,
      engageTheme: null,
      engageVideosOnly: false,
      engageTweetsOnly: false,
      engageTweetsCollapsed: false,
      authStatus: (getAu()?.nt && 'h') || '',
      auDate: new Date() * 1,
      au: null,
      showProfile: false,
      // tracking actions
      engageNotificationClicked: null,
      engageExitClicked: null,
      videoPauseEvent: null,
      toggleFullScreenEvent: null,
      insightClicked: null,
      itemCopied: null,
      videoClicked: null,
      engageTourStep: -1,
      tourShown: false,
      tourInTour: false,
      tourInTourStep: -1,
      focusMode: false,
      widerInsights: initialWiderInsights(),
      engageInsightsCategory: null,
      engageThemesKeywords: '',
      sectionThemesParentFilter: null,
      sectionThemesParentsOnly: false,
      engageAndOr: 'or',
      spotlightTweets: {},
      spotlightVideos: {},
      spotlightSettingsOpen: false,
      spotlightCategory: null,
      spotlightSource: null
    };
    setDefaults(props);
    await loadForage(props);
    //props.customThemes = removeEmptyThemes(props.customThemes);
    // const vuexLocal = new VuexPersistence({
    //   storage: window.localStorage
    // });
    store.instance = new Vuex.Store(
      vuexSimple(
        {
          // plugins: [vuexLocal.plugin],
          //plugins: [new VuexPersistence({ storage: VueLocalforage }).plugin],
          modules: { videosNS, tweetsNS, documentsNS, insightsNS },
          mutations: {
            setLoaded({ loadingImages }, value) {
              Vue.set(loadingImages, value, 'loaded');
            },
            setPending({ loadingImages }, value) {
              console.log('setPending', value);
              Vue.set(loadingImages, value, 'pending');
            },
            toggleSelectedInsightsTheme({ selectedInsightsThemes }, value) {
              console.log('toggleSelectedInsightsTheme value', value);
              if (selectedInsightsThemes[value]) {
                Vue.delete(selectedInsightsThemes, value);
              } else {
                Vue.set(selectedInsightsThemes, value, true);
              }
            },
            toggleSelectedWatchlistTheme({ selectedWatchlistThemes }, value) {
              console.log('toggleSelectedWatchlistTheme value', value);
              if (selectedWatchlistThemes[value]) {
                Vue.delete(selectedWatchlistThemes, value);
              } else {
                Vue.set(selectedWatchlistThemes, value, true);
              }
            },
            toggleEngageSelectedDocument({ engageSelectedDocuments }, value) {
              // console.log('toggleEngageSelectedDocument value', value);
              if (engageSelectedDocuments[value]) {
                Vue.delete(engageSelectedDocuments, value);
              } else {
                Vue.set(engageSelectedDocuments, value, true);
              }
            },
            toggleEngageSelectedPublisher({ engageSelectedPublishers }, value) {
              if (engageSelectedPublishers[value]) {
                Vue.delete(engageSelectedPublishers, value);
              } else {
                Vue.set(engageSelectedPublishers, value, true);
              }
            },
            toggleEngageSelectedTheme({ engageSelectedThemes }, value) {
              if (engageSelectedThemes[value]) {
                Vue.delete(engageSelectedThemes, value);
              } else {
                Vue.set(engageSelectedThemes, value, true);
              }
            },
            toggleSelectedWatchlistPublisher({ selectedWatchlistPublishers: swp }, value) {
              //console.log('selectedWatchlistPublishers value', value);
              if (swp[value]) {
                Vue.delete(swp, value);
              } else {
                Vue.set(swp, value, true);
              }
            },
            toggleSelectedWatchlistDocType({ selectedWatchlistDocTypes: swdt }, value) {
              if (swdt[value]) {
                Vue.delete(swdt, value);
              } else {
                Vue.set(swdt, value, true);
              }
            },
            setThemeName(state, { themePath, name }) {
              Vue.set(state[themePath], 'n', name);
            },
            setThemeAndOr(state, { themePath, andOr }) {
              Vue.set(state[themePath], 'andOr', andOr);
            },
            toggleThemeTag(state, { customTheme, themePath, tag }) {
              if (customTheme) {
                const current = customTheme.selectedTags[tag];
                Vue[(current && 'delete') || 'set'](customTheme.selectedTags, tag, !current);
              } else {
                const current = state[themePath].selectedTags[tag];
                Vue[(current && 'delete') || 'set'](state[themePath].selectedTags, tag, !current);
              }
            },
            editTheme({ customThemes }, value) {
              value.id = value.id || new Date() * 1;
              Vue.set(customThemes, value.id, value);
            },
            removeTheme({ customThemes, selectedThemes }, value) {
              console.log('removeTheme mutation called', value);
              try {
                Vue.delete(selectedThemes, value);
                Vue.delete(customThemes, value);
              } catch (ex) {
                console.log('mutation failed', ex.message);
              }
              console.log('mutation ended');
            },
            addInsights(state, value) {
              const { id } = value;
              state.insightsCache = { ...state.insightsCache, [id]: Object.freeze(value) };
              console.log('commit addInsights', id);
            },
            deleteVideo({ playlist }, value) {
              const index = playlist.findIndex(({ id }) => id === value);
              playlist.splice(index, 1);
              // console.log('deleteVideo', index);
            },
            deletePage({ loadedPages = {} }, { did, pgn }) {
              const pages = loadedPages[did];
              const index = pages?.findIndex(page => page === pgn);
              pages?.splice(index, 1);
              // console.log('deletePage', did, pgn, index);
            },
            deletePageDocument({ loadedPages = {} }, value) {
              Vue.delete(loadedPages, value);
              // console.log('deletePageDocument', value);
            },
            deleteDocument({ loadedDocuments }, value) {
              const index = loadedDocuments?.findIndex(did => did === value);
              loadedDocuments?.splice(index, 1);
              // console.log('deleteDocument', value);
            },
            deleteTweet({ loadedTweets }, value) {
              const index = loadedTweets.findIndex(id => id === value);
              loadedTweets.splice(index, 1);
              // console.log('deleteTweet', index);
            },
            deleteFeed({ loadedFeeds, loadedFeedLps }, value) {
              Vue.delete(loadedFeedLps, value);
              const index = loadedFeeds.findIndex(({ feed: { url } }) => url === value);
              loadedFeeds.splice(index, 1);
              // console.log('deleteFeed', value, index);
            },
            documents(state, value) {
              state.documents = Object.freeze(value);
            },
            select(state, { item, value }) {
              item.selected = value;
            },
            addTweets(state, { item, value }) {
              item.tweets = value;
            },
            addVideos(state, { item, value }) {
              item.videos = value;
            },
            tag(state, { item, value }) {
              if (value) {
                Vue.set(state.selectedTags, item, value);
                // state.selectedTags[item] = value;
              } else {
                Vue.delete(state.selectedTags, item);
                //delete state.selectedTags[item];
              }
            },
            toggleTheme({ selectedThemes }, value) {
              if (selectedThemes[value]) {
                Vue.delete(selectedThemes, value);
              } else {
                Vue.set(selectedThemes, value, true);
              }
            },
            toggleTag({ selectedAllTags }, value) {
              if (selectedAllTags[value]) {
                Vue.delete(selectedAllTags, value);
              } else {
                Vue.set(selectedAllTags, value, true);
              }
            },
            toggleTicker(state, value) {
              const { selectedTickers } = state;
              if (selectedTickers[value]) {
                Vue.delete(selectedTickers, value);
              } else {
                Vue.set(selectedTickers, value, true);
              }
            },
            selectSource({ selectedSourceIds }, value) {
              if (selectedSourceIds[value]) {
                Vue.delete(selectedSourceIds, value);
              } else {
                Vue.set(selectedSourceIds, value, true);
              }
            },
            NOTdocuments(state, value) {
              const cache = {};
              state.documents =
                (value &&
                  value.reduce((deduped, doc) => {
                    // const { did, durl, pgn } = doc;
                    const { did, pgn } = doc;
                    let cacheHit = cache[did];
                    if (!cacheHit) {
                      cacheHit = cache[did] = doc;
                      doc.pages = [];
                      deduped.push(doc);
                    }
                    cacheHit.pages.push(pgn);
                    return deduped;
                  }, [])) ||
                value;
              console.log(Object.keys(cache).length, value && value.length);
            },
            selectDoc({ selectedDocuments }, options) {
              let { item = options, select } = options;
              //item.selected = select === undefined ? !item.selected : select;
              Vue.set(selectedDocuments, item.pgn, select === undefined ? !selectedDocuments[item.pgn] : select);
            },
            resetFolderAge(state) {
              state.folderAge = state.default_folderAge;
            },
            resetInsightsSentiment(state) {
              state.insightsSentiment = state.default_insightsSentiment;
            },
            resetSentiment(state) {
              state.sentiment = state.default_sentiment;
            },
            resetEngagement(state) {
              state.interestingness = state.default_interestingness;
              state.visuality = state.default_visuality;
            },
            selectHero({ selectedHeros }, { did, pgn }) {
              Vue.set(selectedHeros, did, pgn);
            },
            smallDoco({ docoSmallCache }, { did, json }) {
              Vue.set(docoSmallCache, did, json);
            },
            addLoadedFeed({ loadedFeeds }, { lp, index, json }) {
              json.lp = lp;
              loadedFeeds.splice(index, 0, json);
            },
            addFeedJSON(state, { feed, json }) {
              //const feed = loadedFeeds[loadedFeeds.indexOf(value)];
              //console.log('addFeedJSON', feed.feed.url, json);
              json.forEach(item => {
                item.tags = item.tg.reduce((all, tag) => {
                  all[tag] = true;
                  return all;
                }, {});
              });
              Vue.set(feed, 'json', Object.freeze(json));
            },
            addSpotlightVideo({ spotlightVideos }, { search, json }) {
              //todo: handle pagination
              console.log('addSpotlightVideo', search, json);
              Vue.set(spotlightVideos, search, json);
            },
            addSpotlightTweet({ spotlightTweets }, { search, json }) {
              //todo: handle pagination
              console.log('addSpotlightTweet', search, json);
              Vue.set(spotlightTweets, search, json);
            }
            //resetInheritUpper(state) {
            //  state.inheritUpper = state.default_inheritUpper;
            //}
          },
          actions: {
            async fetchSpotlightVideos({ commit, getters: { spotlightVideos = {}, spotlightCategory, spotlightSource, engage: { domains = [], spotlightInfo = {} } = {} } }, value) {
              const search = [value, domains.join('|')].join('__') + (spotlightCategory && `__${ spotlightCategory }` || '') + (spotlightSource && `__${ spotlightSource }` || '');
              if (!spotlightVideos[search]) {
                const category = spotlightCategory && `&ca=${ spotlightCategory }` || '';
                // todo: un ubsify this
                const source = !spotlightSource && `&cid=${ spotlightInfo.sourcesTable?.ubs?.yc }` || '';
                console.log('source', source);
                // const response = await fetch(`https://dsgt1uxjkh3a.cloudfront.net/api/QueryTweets?ath=${ value }&dm=${ domains.join('|') }&c=31`, { referrerPolicy: 'no-referrer-when-downgrade' });
                const response = await fetch(`https://dsgt1uxjkh3a.cloudfront.net/api/QueryVideos?ath=${ value }&dm=${ domains.join('|') }&c=31${ category }${ source }`, { referrerPolicy: 'no-referrer-when-downgrade' });
                const json = Object.freeze((await response.json()) || {});
                if (json?.count) {
                  console.log('success');
                  commit('addSpotlightVideo', { search, json });
                }
              }
            },
            async fetchSpotlightTweets({ commit, getters: { spotlightTweets = {}, spotlightCategory, spotlightSource, engage: { domains = [], spotlightInfo = {} } = {} } }, value) {
              const search = [value, domains.join('|')].join('__') + (spotlightCategory && `__${ spotlightCategory }` || '') + (spotlightSource && `__${ spotlightSource }` || '');
              if (!spotlightTweets[search]) {
                const category = spotlightCategory && `&ca=${ spotlightCategory }` || '';
                // todo: un ubsify this
                const source = !spotlightSource && `&cid=${ spotlightInfo.sourcesTable?.ubs?.yc }` || '';
                console.log('source', source);
                // const response = await fetch(`https://dsgt1uxjkh3a.cloudfront.net/api/QueryTweets?ath=${ value }&dm=${ domains.join('|') }&c=31`, { referrerPolicy: 'no-referrer-when-downgrade' });
                const response = await fetch(`https://dsgt1uxjkh3a.cloudfront.net/api/QueryTweets?ath=${ value }&dm=${ domains.join('|') }&c=31${ category }${ source }`, { referrerPolicy: 'no-referrer-when-downgrade' });
                const json = Object.freeze((await response.json()) || {});
                if (json?.count) {
                  console.log('success');
                  commit('addSpotlightTweet', { search, json });
                }
              }
            },
            au({ commit }, value) {
              console.log('au action', value, btoa(JSON.stringify(value)));
              Vue.cookie.set('au', btoa(JSON.stringify(value)), { domain: cookieDomain() });
              commit('au', value);
              commit('auDate', new Date() * 1);
            },
            async toggleFavorite({ dispatch, getters: { au } }) {
              const { fr = [], nt } = au || {};
              const isFavorite = fr?.includes('w');
              const value = engage();
              // console.log(
              //   'toggleFavorite',
              //   value,
              //   nt,
              //   fr,
              //   `https://h.weave.ai/api/${ (isFavorite && 'un') || '' }follow?w=${ value }&nt=${ nt }&m=1`
              // );
              const response = await fetch(`https://h.weave.ai/api/${ isFavorite && 'un' || '' }follow?w=${ value }&nt=${ nt }&m=1`, { referrerPolicy: 'no-referrer-when-downgrade' });
              const json = Object.freeze((await response.json()) || {});
              if (json?.status === 'success') {
                let newFr = [...fr];
                if (isFavorite) {
                  newFr = newFr.filter(v => v !== 'w');
                } else {
                  newFr.push('w');
                }
                dispatch('au', { ...au, fr: newFr });
              }
              // console.log('toggleFavorite json', json);
            },
            async togglePubFavorite({ dispatch, getters: { au, engage } }) {
              const { fr = [], nt } = au || {};
              const isFavorite = fr?.includes('p');
              const pub = engage?.publisher?.id;
              console.log(
                'togglePubFavorite',
                pub,
                nt,
                fr,
                `https://h.weave.ai/api/${ (isFavorite && 'un') || '' }follow?p=${ pub }&nt=${ nt }&m=1`
              );
              const response = await fetch(`https://h.weave.ai/api/${ isFavorite && 'un' || '' }follow?p=${ pub }&nt=${ nt }&m=1`, { referrerPolicy: 'no-referrer-when-downgrade' });
              const json = Object.freeze((await response.json()) || {});
              if (json?.status === 'success') {
                let newFr = [...fr];
                if (isFavorite) {
                  newFr = newFr.filter(v => v !== 'p');
                } else {
                  newFr.push('p');
                }
                dispatch('au', { ...au, fr: newFr });
              }
              console.log('toggleFavorite json', json);
            },
            roboReportStartTime(
              {
                commit,
                getters: { roboReportEndTime }
              },
              value
            ) {
              if (value * 1 < roboReportEndTime * 1) {
                commit('roboReportStartTime', value);
              }
            },
            roboReportEndTime(
              {
                commit,
                getters: { roboReportStartTime }
              },
              value
            ) {
              if (value * 1 > roboReportStartTime * 1) {
                commit('roboReportEndTime', value);
              }
            },
            async setLoaded({ commit }, value) {
              commit('setLoaded', value);
            },
            async setPending({ commit }, value) {
              commit('setPending', value);
            },
            async toggleSelectedInsightsTheme({ commit }, value) {
              commit('toggleSelectedInsightsTheme', value);
            },
            async toggleEngageSelectedDocument({ commit }, value) {
              commit('toggleEngageSelectedDocument', value);
            },
            async toggleEngageSelectedPublisher({ commit }, value) {
              commit('toggleEngageSelectedPublisher', value);
            },
            async addEngageSelectedPublisher({ commit, getters: { engageSelectedPublishers } }, value) {
              console.log('addEngageSelectedPublisher', engageSelectedPublishers, value);
              if (!engageSelectedPublishers[value]) {
                commit('toggleEngageSelectedPublisher', value);
              }
            },
            async toggleEngageSelectedTheme({ commit }, value) {
              commit('toggleEngageSelectedTheme', value);
            },
            async toggleSelectedWatchlistTheme({ commit }, value) {
              commit('toggleSelectedWatchlistTheme', value);
            },
            async toggleSelectedWatchlistPublisher({ commit }, value) {
              commit('toggleSelectedWatchlistPublisher', value);
            },
            async toggleSelectedWatchlistDocType({ commit }, value) {
              commit('toggleSelectedWatchlistDocType', value);
            },
            async pdf(
              {
                commit,
                dispatch,
                getters: { usePdf }
              },
              value
            ) {
              const next =
                (usePdf === 'a' && 'b') ||
                (usePdf === 'b' && 'c') ||
                (usePdf === 'c' && 'd') ||
                (usePdf === 'd' && 'e') ||
                (usePdf === 'e' && 'f') ||
                (usePdf === 'f' && 'g') ||
                (usePdf === 'g' && 'h') ||
                (usePdf === 'h' && 'i') ||
                (usePdf === 'i' && 'j') ||
                'a';
              await dispatch('usePdf', next);
              commit(`pdf${ next.toUpperCase() }`, value);
              commit('pdf', value);
            },
            setThemeName({ commit, getters }, value) {
              commit('setThemeName', value);
              saveCustomThemes(getters);
            },
            setThemeAndOr({ commit, getters }, value) {
              commit('setThemeAndOr', value);
              saveCustomThemes(getters);
            },
            toggleThemeTag({ commit, getters }, value) {
              commit('toggleThemeTag', value);
              saveCustomThemes(getters);
            },
            editTheme({ commit, getters }, value) {
              commit('editTheme', value);
              saveCustomThemes(getters);
            },
            removeTheme({ commit, getters }, value) {
              commit('removeTheme', value);
              saveCustomThemes(getters);
            },
            deleteVideo({ commit }, value) {
              commit('deleteVideo', value);
            },
            deletePage({ commit }, value) {
              commit('deletePage', value);
            },
            deletePageDocument({ commit }, value) {
              commit('deletePageDocument', value);
            },
            deleteDocument({ commit }, value) {
              commit('deleteDocument', value);
            },
            deleteTweet({ commit }, value) {
              commit('deleteTweet', value);
            },
            deleteFeed({ commit }, value) {
              commit('deleteFeed', value);
            },
            async selectHero(
              {
                commit,
                getters: { selectedHeros }
              },
              value
            ) {
              commit('selectHero', value);
              await Vue.$localforage.setItem('selectedHeros', selectedHeros);
            },
            async lp({ commit }, value) {
              commit('lp', value);
              await Vue.cookie.set('lp', value, { domain: cookieDomain() });
            },
            async token({ commit }, value) {
              commit('token', value);
              await Vue.cookie.set('token', value, { domain: cookieDomain() });
            },
            async lps({ commit }, value) {
              commit('lps', value);
              Vue.cookie.set('lps', JSON.stringify(value), { domain: cookieDomain() });
              await Vue.$localforage.setItem('lps', value);
            },
            async cheatsheetLP(
              {
                commit,
                dispatch,
                getters: { lpServer, logos }
              },
              value
            ) {
              console.log('cheatsheetLP action');
              const r = await fetch(`${ lpServer }/lp/${ value }`);
              const json = await r.json();
              console.log('cheatsheetLP', json);
              if (json) {
                commit('cheatsheetJSON', JSON.stringify(json));
                commit('cheatsheetKeys', Object.freeze(Object.keys(json)));
                commit('cheatsheet', json);
              }
              const { title, pages, insights, videos: playlist, documents, tweets, feeds, logo } = json || {};
              if (pages) {
                //await dispatch('loadedPages', Object.freeze(pages));
                await dispatch('loadedPages', pages);
              }
              if (documents) {
                await dispatch('loadedDocuments', documents);
              }
              if (tweets) {
                await dispatch('loadedTweets', tweets);
              }
              if (feeds) {
                await dispatch('loadedFeedLps', feeds);
                await dispatch('loadedFeeds', []);
                Object.values(feeds).forEach(async (f, index) => {
                  let json;
                  try {
                    const r = await fetch(`${ lpServer }/lp/${ f }`);
                    json = await r.json();
                    console.log('cheatsheet feeds', json);
                    if (json) {
                      commit('addLoadedFeed', { lp: f, index, json });
                    }
                  } catch (ex) {
                    console.log('error loading feed json', f, json);
                  }
                });
              }
              if (insights) {
                await dispatch(
                  // not doing Object.freeze because the keys are the data
                  'insightsNS/loadedInsights',
                  insights
                );
              }
              if (playlist) {
                await dispatch('playlist', playlist.map(item => Object.freeze(item)));
              }
              const t = 'Cheat Sheet';
              commit('cheatsheetLP', value);
              commit('title', t);
              if (title) {
                document.title = title;
                commit('loadedTitle', title);
              } else {
                document.title = 'Cheat Sheet ' + value;
              }
              if (logo) {
                commit('logo', logo);
              }
            },
            fetchFeeds({ commit, getters: { loadedFeeds: feeds } }) {
              //const json = value;
              (feeds || []).forEach(async feed => {
                //console.log('fetchFeeds feed', feed);
                const {
                  feed: { url },
                  type
                } = feed;
                const start = new Date();
                console.log('fetchFeeds', url);
                const r = await fetch(url);
                const mid = new Date();
                console.log('fetchFeeds response', (mid - start) / 1000, r);
                const json = await r.json();
                const mid2 = new Date();
                console.log('fetchFeeds response', (mid2 - mid) / 1000, r);
                let { results } = json;
                if (type === 'documents') {
                  //todo: collect tags;
                  const firstPages = results.filter(({ id }) => /\-1$/.test(id));
                  console.log("type === 'documents'", (new Date() - mid2) / 1000, results.length);
                  results = firstPages;
                }
                commit('addFeedJSON', { feed, json: results });
              });
            },
            // loadedPages({ commit }, value) {
            //   commit('loadedPages', value);
            //   //console.log('loadedPages', value);
            // },
            async toggleTheme(
              {
                commit,
                dispatch,
                getters: { selectedThemes }
              },
              value
            ) {
              await commit('toggleTheme', value);
              dispatch('selectedVis', (Object.keys(selectedThemes || {}).length && 'selectedThemes') || 'topThemes');
              Vue.$localforage.setItem('selectedThemes', selectedThemes);
            },
            toggleTag(
              {
                commit,
                getters: { selectedAllTags }
              },
              value
            ) {
              commit('toggleTag', value);
              Vue.$localforage.setItem('selectedAllTags', selectedAllTags);
            },
            async select({ commit, dispatch, getters }, { item, value }) {
              if (item.type === 'ticker') {
                console.log('select', item.id);
                await dispatch('toggleTicker', item.id);
              } else {
                commit('select', { item, value });
              }
              if (!getters.selected?.length) {
                dispatch('videos', null);
                dispatch('tweets', null);
                dispatch('documents', null);
                dispatch('videosShown', false);
                dispatch('tweetsShown', false);
                dispatch('documentsShown', false);
              }
              ['videosNS/', 'tweetsNS/', 'documentsNS/'].forEach(ns => {
                Object.entries({
                  Tags: {},
                  Sectors: [],
                  Categories: [],
                  SourceIds: {}
                }).forEach(([facet, value]) => dispatch(ns + 'selected' + facet, value));
                // }).forEach(([facet, value]) => {
                //   console.log('select action', ns + 'selected' + facet, value);
                //   dispatch(ns + 'selected' + facet, value)
                // });
              });
              await fetchMedia(store(), undefined, true);
              await fetchMedia(store(), 'tweet', true);
              // todo: fetch documents
              await fetchMedia(store(), 'document', true);
            },
            selectDoc(
              {
                commit,
                getters: { documents, selectedDocuments }
              },
              value
            ) {
              commit('selectDoc', value);
              //console.log('selectDoc', value);
              if (!('select' in value)) {
                commit(
                  'customSelection',
                  documents
                    .filter(({ pgn }) => selectedDocuments[pgn])
                    .reduce((all, item) => {
                      all[item.pgn] = 1;
                      return all;
                    }, {})
                );
                commit('selectAll', 'custom');
              }
            },
            readingList({ commit, dispatch }, value) {
              commit('readingList', value);
              //console.log('readingList', value);
              if (value?.length) {
                // const encoded = value.map(id => id.replace(/\s/g, '%20').replace(/\,/g, '%2c'));
                // console.log('readingList encoded', encoded);
                history.replaceState(
                  {},
                  document.title,
                  location.href.replace(/([\?\;\&]rl\=\[)([^\]]+)(\])/, `$1${ value.join(',') }$3`)
                );
                dispatch('license', null);
              }
            },
            readingListOpen({ commit, dispatch }, value) {
              commit('readingListOpen', value);
              if (!value) {
                dispatch('dropBefore', null);
              }
            },
            readingListIndex({ commit }, value) {
              commit('readingListIndex', value);
              console.log('23422', location.href.replace(/([\?\;\&]rli\=)(\d+)/, `$1${ value }`));
              // console.log('23422', location.href.replace(/([\?\;\&]rl\=\[)([^\]]+)(\])/, `$1${ value.join(',') }$3`));
              let url = location.href.replace(/([\?\;\&]rli\=)(\d+)/, `$1${ value }`);
              if (!/rli\=/.test(url)) {
                url += ';rli=' + value;
              }
              history.replaceState({}, document.title, url);
            },
            selectAll(
              {
                commit,
                getters: { documents, customSelection }
              },
              value
            ) {
              //console.log(value);
              if ({ all: 1, none: 1 }[value]) {
                documents.forEach(item => commit('selectDoc', { item, select: value === 'all' }));
                //dispatch('selectAll', 'custom');
              } else if (value === 'revelant') {
                // todo: select by relevant
              } else {
                documents.forEach(item => commit('selectDoc', { item, select: !!customSelection[item.pgn] }));
              }
              commit('selectAll', value);
            },
            async resetFolderAge({ commit }) {
              commit('resetFolderAge');
              // dispatch('fetchMedia');
            },
            async resetInsightsSentiment({ commit }) {
              commit('resetInsightsSentiment');
              // dispatch('fetchMedia');
            },
            async resetSentiment({ commit }) {
              commit('resetSentiment');
              // dispatch('fetchMedia');
            },
            async resetEngagement({ commit }) {
              commit('resetEngagement');
              // dispatch('fetchMedia');
            },
            //async resetInheritUpper({ commit }) {
            //  commit('resetInheritUpper');
            //  // dispatch('fetchMedia');
            //},
            //async inheritUpper(
            //  {
            //    commit,
            //    getters: { inheritUpper, default_inheritUpper }
            //  },
            //  value
            //) {
            //  if (default_inheritUpper === null) {
            //    commit('default_inheritUpper', inheritUpper);
            //  }
            //  commit('inheritUpper', value);
            //},
            async folderAge(
              {
                commit,
                getters: { folderAge, default_folderAge, lazyLevel }
              },
              [min, max]
            ) {
              // if (!default_folderAge) {
              //   commit('default_folderAge', folderAge);
              // }
              if (min === max) {
                if (max === 10) {
                  min -= 1;
                } else {
                  max += 1;
                }
              }
              if (lazyLevel < 100) {
                commit('folderAge', [min, max]);
                // console.log('set forage folderAge', [min, max], lazyLevel);
                // await Vue.$localforage.setItem('folderAge', [min, max]);
              }
              if (default_folderAge) {
                // await dispatch('fetchMedia');
              }
            },
            async insightsSentiment(
              {
                commit,
                getters: { insightsSentiment, default_insightsSentiment, lazyLevel }
              },
              [min, max]
            ) {
              // if (!default_insightsSentiment) {
              //   commit('default_insightsSentiment', insightsSentiment);
              // }
              if (min === max) {
                if (max === 5) {
                  min -= 1;
                } else {
                  max += 1;
                }
              }
              if (lazyLevel < 100) {
                commit('insightsSentiment', [min, max]);
                // console.log('set forage insightsSentiment', [min, max], lazyLevel);
                // await Vue.$localforage.setItem('insightsSentiment', [min, max]);
              }
              if (default_insightsSentiment) {
                // await dispatch('fetchMedia');
              }
            },
            async sentiment(
              {
                commit,
                getters: { sentiment, default_sentiment, lazyLevel }
              },
              [min, max]
            ) {
              // if (!default_sentiment) {
              //   commit('default_sentiment', sentiment);
              // }
              if (min === max) {
                if (max === 5) {
                  min -= 1;
                } else {
                  max += 1;
                }
              }
              if (lazyLevel < 100) {
                commit('sentiment', [min, max]);
                // console.log('set forage sentiment', [min, max], lazyLevel);
                // await Vue.$localforage.setItem('sentiment', [min, max]);
              }
              if (default_sentiment) {
                // await dispatch('fetchMedia');
              }
            },
            async interestingness(
              {
                commit,
                getters: { interestingness, default_interestingness }
              },
              [min, max]
            ) {
              if (!default_interestingness) {
                commit('default_interestingness', interestingness);
              }
              if (min === max) {
                if (max === 5) {
                  min -= 1;
                } else {
                  max += 1;
                }
              }
              commit('interestingness', [min, max]);
              if (default_interestingness) {
                // await dispatch('fetchMedia');
              }
            },
            async visuality(
              {
                commit,
                getters: { visuality, default_visuality }
              },
              [min, max]
            ) {
              if (!default_visuality) {
                commit('default_visuality', visuality);
              }
              if (min === max) {
                if (max === 5) {
                  min -= 1;
                } else {
                  max += 1;
                }
              }
              commit('visuality', [min, max]);
              if (default_visuality) {
                // await dispatch('fetchMedia');
              }
            },
            addTweets({ commit }, value) {
              commit('addTweets', value);
            },
            addVideos({ commit }, value) {
              commit('addVideos', value);
            },
            nextVideo({ commit, getters: { nextVideo, player } }) {
              commit('currentVideo', nextVideo);
              if (nextVideo && player) {
                player.cueVideoById(nextVideo.id);
                setTimeout(() => {
                  try {
                    player.playVideo();
                    commit('playing', true);
                  } catch (ex) {}
                }, 100);
              }
            },
            prevVideo({ commit, getters: { prevVideo, player } }) {
              commit('currentVideo', prevVideo);
              if (prevVideo && player) {
                player.cueVideoById(prevVideo.id);
                setTimeout(() => {
                  try {
                    player.playVideo();
                    commit('playing', true);
                  } catch (ex) {}
                }, 100);
              }
            },
            tag({ commit }, value) {
              commit('tag', value);
            },
            toggle({ commit }, value) {
              commit('toggle', value);
            },
            tweetsShown({ commit }, value) {
              commit('tweetsShown', value);
              if (value) {
                commit('shown', false);
              }
            },
            videosShown({ commit }, value) {
              commit('videosShown', value);
              if (value) {
                commit('shown', false);
              }
            },
            documentsShown({ commit }, value) {
              commit('documentsShown', value);
              if (value) {
                commit('shown', false);
              }
            },
            scenes(
              {
                commit,
                getters: { selected, title, topo }
              },
              value
            ) {
              if (selected?.length) {
                commit('persistedSelection', [...selected]);
                console.log(selected);
              }
              commit(
                'scenes',
                Object.entries(value).map(([k, v]) => {
                  v.id = k;
                  v.title = (v && v.t) || k;
                  v.search = `${ v.search || v.title }|${ (v.al || []).join('|') }`;
                  v.selected = false;
                  v.topo = { title, id: topo };
                  return v;
                })
              );
            },
            async smallDocos({
                               commit,
                               getters: {
                                 readingList,
                                 folderList,
                                 docoSmallCache,
                                 'insightsNS/cheatsheet': cheatsheet,
                                 loadedPages,
                                 loadedDocuments
                               }
                             }) {
              //const dsc = window.docoSmallCache = window.docoSmallCache || {};
              // const dsc = window.docoSmallCache = window.docoSmallCache || {};
              //const dsc = {};
              const dids = (readingList || []).filter(did => !/^\|/.test(did));
              const insightsPageDids = Object.keys(cheatsheet?.documents) || [];
              // console.log('loadedPages', loadedPages);
              const folderDids = Object.keys(folderList || {});
              Object.keys(loadedPages || {})
                .concat(folderDids)
                .concat(insightsPageDids)
                .concat(loadedDocuments || [])
                .forEach(did => {
                  if (!dids.includes(did)) {
                    dids.push(did);
                  }
                });
              // Object.keys(store.getters["insightsNS/cheatsheet"].documents)
              await Promise.all(dids.map(fetchOne));
              await Vue.$localforage.setItem('docoSmallCache', docoSmallCache);
              return docoSmallCache;
              async function fetchOne(did) {
                let json = docoSmallCache[did];
                console.log('fetching?', did, json);
                if (!json) {
                  const response = await fetch(
                    `https://d1l6gufwe1p5x2.cloudfront.net/api/topoqa/getdocsummarybyid?id=${ did }`
                  );
                  json = await response.json();
                  const { Result: results, Message: message = 'small doco no results' } = json || {};
                  if (results) {
                    commit('smallDoco', { did, json: Object.freeze(results) });
                  } else {
                    console.log('small doco message', message);
                  }
                }
                // dsc[did] = dsc[did] || json;
              }
            },
            roboWeaveShown(
              {
                dispatch,
                commit,
                getters: { roboWeaveTitle }
              },
              value
            ) {
              commit('roboWeaveShown', value);
              console.log('roboWeaveShown', value, roboWeaveTitle);
              if (value) {
                dispatch('loadedTitle', roboWeaveTitle);
                dispatch('title', roboWeaveTitle);
              }
            },
            async morphThemes({ dispatch, getters: { parentThemesTable: ptt } }, value) {
              const [name, themes] = Object.entries(value)[0];
              //console.log('morphThemes', name, themes);
              const thms = Object.entries(themes)
                .map(([index, { th, c, cr, ps }]) => ({ ...th, c, cr, ps, index }))
                .sort((a, b) => b.c - a.c)
                .reduce((all, th) => {
                  all[th.n] = th;
                  return all;
                }, {});
              //console.log('morphThemes', 'first morph done', thms);
              Object.values(thms)
                .filter(({ cth }) => cth?.length)
                .forEach(th => {
                  const { cth, index } = th;
                  th.k = Object.keys(
                    cth.reduce((all, { n }) => {
                      thms[n]?.k.forEach(w => (all[w] = true));
                      return all;
                    }, {})
                  );
                  const weights = ptt[index]?.t;
                  if (weights) {
                    th.cth = cth.map(c => {
                      const index = thms?.[c?.n]?.index;
                      const r = c;
                      if (index > -1) {
                        const cr = weights?.[thms?.[c?.n]?.index];
                        if (cr > -1) {
                          r.cr = cr;
                        }
                      }
                      return r;
                    });
                  }
                  // console.log(th.n, th.k, cth, weights);
                });
              // console.log(thms);
              //console.log('dispatch themes for', name || 'no name', thms);
              await dispatch(name, Object.freeze(thms));
            },
            async morphAnalytics({ dispatch }, value) {
              const { themes } = value;
              const [name, analytics] = Object.entries(value)[0];
              //console.log('morphAnalytics', name, analytics, value);
              try {
                console.log('morphing...');
                const {
                  thd,
                  thd: { pt }
                } = analytics;
                console.log('morph', pt || 42, thd);
                thd.tht = Object.entries(thd.tht).reduce((map, [index, th]) => {
                  map[themes[index].th.n] = th;
                  const { pwt } = th;
                  if (pwt && pt) {
                    th.pwt = Object.entries(pwt).reduce((map, [i, v]) => {
                      map[pt[i]] = v;
                      return map;
                    }, {});
                  }
                  //th.pwt =
                  /*
                                      .map(([key, value]) => {
                      const { pwt } = value;
                      if (pwt && pt) {
                        value.pwt = Object.entries(pwt).reduce((map, [k, v]) => {
                          map[pt[k]] = v;
                          return map;
                        }, {});
                      }
                      return [key, value];
                    })

                  */
                  return map;
                }, {});
                console.log('... morph done');
                await dispatch(name, Object.freeze(analytics));
              } catch (ex) {
                console.log('analytics mapping error:', ex.message);
              }
            },
            async loadRoboReport({
                                   dispatch,
                                   getters: {
                                     roboReportUrl: url,
                                     defaultRoboReportUrl
                                   }
                                 }) {
              if (url !== defaultRoboReportUrl) {
                dispatch('addLoader', 'loadRoboReport');
                const priorFetches = [...roboReportFetches];
                const ac = new AbortController();
                const { signal } = ac;
                roboReportFetches.push({
                  url,
                  cancel() {
                    //console.log('canceling fetch', this.url || 'no url');
                    try {
                      ac.abort();
                    } catch (ex) {}
                  }
                });
                const response = await fetch(url, { signal });
                //console.log('priorFetches.length', priorFetches.length);
                priorFetches.forEach(pf => {
                  try {
                    pf.cancel();
                  } catch (ex) {}
                });
                priorFetches.length = 0;
                if (!signal.aborted) {
                  const json = Object.freeze((await response.json()) || {});
                  //const { script: { title, folderLinks, feedGroups = [] }, trendingDocs = [], trendingVideos = [], trendingTweets = [], analytics = {}, themes = {}, publishers } = json;
                  //console.log('setting roboReport', url);
                  dispatch('roboReport', json);
                  dispatch('removeLoader');
                }
              }
            },
            async loadEngageRoboReport({
                                         dispatch,
                                         getters: {
                                           engageRoboReportUrl: url,
                                           defaultEngageRoboReportUrl
                                         }
                                       }) {
              // todo: make this check work?
              // todo: caching
              console.log('loadEngageRoboReport action', url);
              if (true || url !== defaultEngageRoboReportUrl) {
                dispatch('addLoader', 'loadEngageRoboReport');
                const priorFetches = [...engageRoboReportFetches];
                const ac = new AbortController();
                const { signal } = ac;
                engageRoboReportFetches.push({
                  url,
                  cancel() {
                    //console.log('canceling fetch', this.url || 'no url');
                    ac.abort();
                  }
                });
                //console.log('loadEngageRoboReport url', url);
                const response = await fetch(url, { signal });
                //console.log('priorFetches.length', priorFetches.length);
                priorFetches.forEach(pf => {
                  try {
                    pf.cancel();
                  } catch (ex) {}
                });
                priorFetches.length = 0;
                if (!signal.aborted) {
                  const json = Object.freeze((await response.json()) || {});
                  //const { script: { title, folderLinks, feedGroups = [] }, trendingDocs = [], trendingVideos = [], trendingTweets = [], analytics = {}, themes = {}, publishers } = json;
                  console.log('setting engageRoboReport', json);
                  dispatch('engageRoboReport', json);
                  dispatch('removeLoader');
                }
              }
            },
            async loadRobo({ dispatch }, value) {
              const url = `https://api.weave.ai/cs/manifests/${ value }.json`;
              await dispatch('robo', value);
              await dispatch('roboWeaveShown', true);
              await dispatch('addLoader', 'loadRobo');
              console.log('fetching robo?', value);
              const response = await fetch(url);
              const json = Object.freeze((await response.json()) || {});
              const {
                script: { title, folderLinks, feedGroups = [] },
                trendingDocs = [],
                trendingVideos = [],
                trendingTweets = [],
                analytics = {},
                themes = {},
                publishers
              } = json;
              const roboTitle = 'Weave - ' + title;
              document.title = roboTitle;
              dispatch('title', roboTitle);
              console.log('loadRobo title', roboTitle);
              dispatch('roboWeaveTitle', roboTitle);
              dispatch('loadedTitle', roboTitle);
              if (publishers) {
                dispatch('roboPublishers', Object.freeze(publishers));
              }
              await dispatch('morphAnalytics', { analytics, themes });
              await dispatch('morphThemes', { roboThemes: themes });
              //console.log('themes', themes);
              /*
              const thms = Object.freeze(Object.values(themes).map(({ th, c }) => ({ ...th, c })).sort((a, b) => b.c - a.c).reduce((all, th) => {
                //console.log(th.n, th.c);
                all[th.n] = th;
                return all;
              }, {}));
              dispatch('themes', thms);
               */
              console.log('folderLinks', folderLinks);
              const flc = await Promise.all(
                folderLinks.map(async ({ name: fl }) => await dispatch('loadFolderLite', fl))
              );
              await dispatch(
                'folderLiteCache',
                flc.reduce((all, { value, json }) => {
                  all[value] = json;
                  return all;
                }, {})
              );
              //await dispatch('folderList', []);
              console.log('flc', flc);
              await dispatch('removeLoader');
              const [feedGroup] = feedGroups;
              const { tweetFeeds = [], videoFeeds = [] } = feedGroup || {};
              //const feeds = [...tweetFeeds, ...videoFeeds].sort((a, b) => b.desktopFeed.timeStamp - a.desktopFeed.timeStamp);
              console.log('feeds...');
              const feeds = await Promise.all(
                [...tweetFeeds, ...videoFeeds]
                  .sort((a, b) => b.desktopFeed.timeStamp - a.desktopFeed.timeStamp)
                  .map(async f => {
                    const { sources, title, desktopFeed = {} } = f || {};
                    desktopFeed.thumbnail = desktopFeed.thumbnail || {};
                    const {
                      tweetsUrl,
                      videosUrl,
                      docsUrl,
                      thumbnail: { url: thumbnail }
                    } = desktopFeed;
                    const url = tweetsUrl || videosUrl || docsUrl;
                    desktopFeed.type = (desktopFeed.type || '').toLowerCase();
                    return Object.freeze({
                      ...desktopFeed,
                      feed: {
                        thumbnail,
                        title,
                        url
                      },
                      srcs: sources,
                      ...(await dispatch('fetchFeedJson', url))
                    });
                  })
              );
              console.log('feeds', feeds);
              dispatch('feeds', feeds);
              //console.log('trending', trendingDocs, trendingVideos, trendingTweets);
              const trending = [...trendingVideos, ...trendingDocs, ...trendingTweets]
                .map(t => {
                  const { folderName } = t;
                  return {
                    ...t,
                    items: (t.docs || t.videos || t.tweets).results?.map(item => ({
                      ...item,
                      folderName,
                      type: (t.docs && 'document') || (t.videos && 'video') || 'tweet'
                    }))
                  };
                })
                .reduce((all, item) => all.concat(item.items), [])
                .sort((a, b) => new Date(b.pa || b.dpa) - new Date(a.pa || a.dpa));
              console.log('trending', trending);
              dispatch('trending', trending);
              return;
              Object.values(docs).forEach(doc => {
                doc.th = (doc.thi || []).map(({ i }) => {
                  const t = { ...themes[i].th, c: themes[i].c };
                  return t.n;
                });
                doc.themes = (doc.thi || []).reduce((all, thi, i) => {
                  all[doc.th[i]] = thi;
                  return all;
                }, {});
                doc.tg = [].concat(
                  ...(doc.thi || []).map(({ i }) => {
                    const t = { ...themes[i].th, c: themes[i].c };
                    return t.k;
                  })
                );
              });
              dispatch('folderList', docs);
              // const thms = Object.freeze(Object.values(themes).map(({ th, c }) => ({ ...th, c })).sort((a, b) => b.c - a.c).reduce((all, th) => {
              //       //console.log(th.n, th.c);
              //       all[th.n] = th;
              //       return all;
              //     }, {}));
              // //console.log('thms', JSON.stringify(thms, null, 2));
              // dispatch('themes', thms);
              const folderTitle = 'Weave - ' + title;
              document.title = folderTitle;
              dispatch('title', folderTitle);
              dispatch('loadedTitle', folderTitle);
              //const { Result: results, Message: message = 'small doco no results' } = json || {};
              await dispatch('removeLoader');
            },
            async loadWatchlist({ dispatch }, value) {
              const url = `https://api.weave.ai/cs/manifests/${ value }.json`;
              await dispatch('robo', value);
              // await dispatch('robo', value);
              await dispatch('roboWeaveShown', true);
              await dispatch('addLoader', 'loadWatchlist');
              console.log('fetching watchlist', value);
              const response = await fetch(url);
              const json = Object.freeze((await response.json()) || {});
              console.log(Object.keys(json.analytics));
              console.log('wl', json);
              const {
                script: {
                  title,
                  folderLinks,
                  feedGroups = [],
                  feedCategories = [],
                  actions = {},
                  industry,
                  primaryThemeConcept
                },
                trendingDocs = [],
                trendingVideos = [],
                trendingTweets = [],
                analytics = {},
                themes = {},
                publishers,
                docTypes = {},
                docTypeCodes = {},
                parentThemesTable = {},
                watchList: watchlist = {}
              } = json;
              console.log('feedCategories', feedCategories);
              const watchlistTitle = 'Weave - ' + title;
              document.title = watchlistTitle;
              dispatch('title', watchlistTitle);
              dispatch('watchlistTitle', watchlistTitle);
              dispatch('industry', industry);
              dispatch('primaryThemeConcept', primaryThemeConcept);
              // console.log('parent themes', themes, Object.entries(themes).filter(([_, { cth }]) => cth).length);
              dispatch('parentThemesTable', Object.freeze(parentThemesTable));
              if (publishers) {
                dispatch('watchlistPublishers', Object.freeze(publishers));
              }
              dispatch('watchListFeedCategories', Object.freeze(feedCategories));
              //dispatch('watchListSelectedFeedCategories', Object.freeze({}));
              if (Object.keys(docTypes).length) {
                // console.log('docTypes, docTypeCodes', docTypes, docTypeCodes);
                if (Object.keys(docTypeCodes).length) {
                  console.log('have codes');
                  const dtc = Object.entries(docTypeCodes).reduce((map, [k, { t, g }]) => {
                    map[t] = { k, t, parentTheme: g };
                    return map;
                  }, {});
                  const dts = Object.entries(docTypes)
                    .sort((a, b) => {
                      return b[1].c - a[1].c;
                    })
                    .reduce((map, [_, { t, c }]) => {
                      const dt = dtc[t];
                      map[dt.k] = { t, c };
                      map[dt.k] = t;
                      return map;
                    }, {});
                  //console.log(Object.keys(dts), dts);
                  dispatch('watchlistDocTypes', dts);
                } else {
                  console.log('docTypes json', JSON.stringify(docTypes));
                  dispatch('watchlistDocTypes', docTypes);
                }
              }
              if (Object.keys(actions).length) {
                const { hideESG, hideAnalytics, customActions } = actions;
                console.log('hideESG, hideAnalytics, customsActions', hideESG, hideAnalytics, customActions);
                if (hideESG) {
                  dispatch('watchlistHideESG', true);
                }
                if (hideAnalytics) {
                  dispatch('watchlistHideAnalytics', true);
                }
                if (customActions) {
                  const ca = customActions.map(({ label, theme }) => ({ label: label.length > 4 && label.substr(0, 1) || label, theme }));
                  dispatch('watchlistCustomActions', ca);
                }
              }
              await dispatch('morphAnalytics', { watchlistAnalytics: analytics, themes });
              //dispatch('watchlistAnalytics', Object.freeze(analytics));
              dispatch('watchlist', Object.freeze(watchlist));
              /*
              const thms = Object.freeze(Object.values(themes).map(({ th, c }) => ({ ...th, c })).sort((a, b) => b.c - a.c).reduce((all, th) => {
                //console.log(th.n, th.c);
                all[th.n] = th;
                return all;
              }, {}));
              dispatch('themes', thms);
               */
              await dispatch('morphThemes', { watchlistThemes: themes });
              // console.log('folderLinks', folderLinks);
              // const flc = (await Promise.all(folderLinks.map(async ({ name: fl }) => await dispatch('loadFolderLite', fl))));
              // await dispatch('folderLiteCache', flc.reduce((all, { value, json }) => {
              //     all[value] = json;
              //     return all;
              //   }, {})
              // );
              // //await dispatch('folderList', []);
              // console.log('flc', flc);
              await dispatch('removeLoader', 'loadWatchlist');
              const [feedGroup] = feedGroups;
              const { tweetFeeds = [], videoFeeds = [] } = feedGroup || {};
              //const feeds = [...tweetFeeds, ...videoFeeds].sort((a, b) => b.desktopFeed.timeStamp - a.desktopFeed.timeStamp);
              console.log('feeds...');
              const feeds = await Promise.all(
                [...tweetFeeds, ...videoFeeds]
                  .sort((a, b) => b.desktopFeed.timeStamp - a.desktopFeed.timeStamp)
                  .map(async f => {
                    const { sources, title, desktopFeed = {} } = f || {};
                    const {
                      tweetsUrl,
                      videosUrl,
                      docsUrl,
                      thumbnail: { url: thumbnail }
                    } = desktopFeed;
                    const url = tweetsUrl || videosUrl || docsUrl;
                    desktopFeed.type = (desktopFeed.type || '').toLowerCase();
                    return Object.freeze({
                      ...desktopFeed,
                      feed: {
                        thumbnail,
                        title,
                        url
                      },
                      srcs: sources,
                      ...(await dispatch('fetchFeedJson', url))
                    });
                  })
              );
              console.log('feeds', feeds);
              dispatch('watchlistFeeds', feeds);
              //console.log('trending', trendingDocs, trendingVideos, trendingTweets);
              const trending = [...trendingVideos, ...trendingDocs, ...trendingTweets]
                .map(t => {
                  const { folderName } = t;
                  return {
                    ...t,
                    items: (t.docs || t.videos || t.tweets).results?.map(item => ({
                      ...item,
                      folderName,
                      type: (t.docs && 'document') || (t.videos && 'video') || 'tweet'
                    }))
                  };
                })
                .reduce((all, item) => all.concat(item.items), [])
                .sort((a, b) => new Date(b.pa || b.dpa) - new Date(a.pa || a.dpa));
              console.log('trending', trending);
              dispatch('watchlistTrending', trending);
            },
            async loadWatchlistLite({ dispatch }, value) {
              const url = `https://api.weave.ai/cs/manifests/${ value }.json`;
              // await dispatch('robo', value);
              // await dispatch('robo', value);
              // await dispatch('roboWeaveShown', true);
              // await dispatch('addLoader', 'loadWatchlist');
              console.log('fetching watchlist', value);
              const response = await fetch(url);
              const json = Object.freeze((await response.json()) || {});
              // console.log(Object.keys(json.analytics));
              // console.log('wl', json);
              const {
                // script: {
                //   title,
                //   // folderLinks,
                //   // feedGroups = [],
                //   // feedCategories = [],
                //   // actions = {},
                //   // industry,
                //   // primaryThemeConcept
                // },
                // trendingDocs = [],
                // trendingVideos = [],
                // trendingTweets = [],
                analytics = {},
                themes = {},
                publishers,
                // docTypes = {},
                // docTypeCodes = {},
                parentThemesTable = {},
                watchList: watchlist = {}
              } = json;
              // console.log('feedCategories', feedCategories);
              // const watchlistTitle = 'Weave - ' + title;
              // document.title = watchlistTitle;
              // dispatch('title', watchlistTitle);
              // dispatch('watchlistTitle', watchlistTitle);
              // dispatch('industry', industry);
              // dispatch('primaryThemeConcept', primaryThemeConcept);
              // console.log('parent themes', themes, Object.entries(themes).filter(([_, { cth }]) => cth).length);
              await dispatch('parentThemesTable', Object.freeze(parentThemesTable));
              if (publishers) {
                await dispatch('watchlistPublishers', Object.freeze(publishers));
              }
              // dispatch('watchListFeedCategories', Object.freeze(feedCategories));
              //dispatch('watchListSelectedFeedCategories', Object.freeze({}));
              // if (Object.keys(docTypes).length) {
              //   // console.log('docTypes, docTypeCodes', docTypes, docTypeCodes);
              //   if (Object.keys(docTypeCodes).length) {
              //     console.log('have codes');
              //     const dtc = Object.entries(docTypeCodes).reduce((map, [k, { t, g }]) => {
              //       map[t] = { k, t, parentTheme: g };
              //       return map;
              //     }, {});
              //     const dts = Object.entries(docTypes)
              //       .sort((a, b) => {
              //         return b[1].c - a[1].c;
              //       })
              //       .reduce((map, [_, { t, c }]) => {
              //         const dt = dtc[t];
              //         map[dt.k] = { t, c };
              //         map[dt.k] = t;
              //         return map;
              //       }, {});
              //     //console.log(Object.keys(dts), dts);
              //     dispatch('watchlistDocTypes', dts);
              //   } else {
              //     console.log('docTypes json', JSON.stringify(docTypes));
              //     dispatch('watchlistDocTypes', docTypes);
              //   }
              // }
              // if (Object.keys(actions).length) {
              //   const { hideESG, hideAnalytics, customActions } = actions;
              //   console.log('hideESG, hideAnalytics, customsActions', hideESG, hideAnalytics, customActions);
              //   if (hideESG) {
              //     dispatch('watchlistHideESG', true);
              //   }
              //   if (hideAnalytics) {
              //     dispatch('watchlistHideAnalytics', true);
              //   }
              //   if (customActions) {
              //     const ca = customActions.map(({ label, theme }) => ({ label: label.length > 4 && label.substr(0, 1) || label, theme }));
              //     dispatch('watchlistCustomActions', ca);
              //   }
              // }
              await dispatch('morphAnalytics', { watchlistAnalytics: analytics, themes });
              await dispatch('watchlistAnalytics', Object.freeze(analytics));
              await dispatch('watchlist', Object.freeze(watchlist));
              await dispatch('morphThemes', { watchlistThemes: themes });
              // console.log('folderLinks', folderLinks);
              // const flc = (await Promise.all(folderLinks.map(async ({ name: fl }) => await dispatch('loadFolderLite', fl))));
              // await dispatch('folderLiteCache', flc.reduce((all, { value, json }) => {
              //     all[value] = json;
              //     return all;
              //   }, {})
              // );
              // //await dispatch('folderList', []);
              // console.log('flc', flc);
              // await dispatch('removeLoader', 'loadWatchlist');
              // const [feedGroup] = feedGroups;
              // const { tweetFeeds = [], videoFeeds = [] } = feedGroup || {};
              //const feeds = [...tweetFeeds, ...videoFeeds].sort((a, b) => b.desktopFeed.timeStamp - a.desktopFeed.timeStamp);
              // console.log('feeds...');
              // const feeds = await Promise.all(
              //   [...tweetFeeds, ...videoFeeds]
              //     .sort((a, b) => b.desktopFeed.timeStamp - a.desktopFeed.timeStamp)
              //     .map(async f => {
              //       const { sources, title, desktopFeed = {} } = f || {};
              //       const {
              //         tweetsUrl,
              //         videosUrl,
              //         docsUrl,
              //         thumbnail: { url: thumbnail }
              //       } = desktopFeed;
              //       const url = tweetsUrl || videosUrl || docsUrl;
              //       desktopFeed.type = (desktopFeed.type || '').toLowerCase();
              //       return Object.freeze({
              //         ...desktopFeed,
              //         feed: {
              //           thumbnail,
              //           title,
              //           url
              //         },
              //         srcs: sources,
              //         ...(await dispatch('fetchFeedJson', url))
              //       });
              //     })
              // );
              // console.log('feeds', feeds);
              // dispatch('watchlistFeeds', feeds);
              //console.log('trending', trendingDocs, trendingVideos, trendingTweets);
              // const trending = [...trendingVideos, ...trendingDocs, ...trendingTweets]
              //   .map(t => {
              //     const { folderName } = t;
              //     return {
              //       ...t,
              //       items: (t.docs || t.videos || t.tweets).results?.map(item => ({
              //         ...item,
              //         folderName,
              //         type: (t.docs && 'document') || (t.videos && 'video') || 'tweet'
              //       }))
              //     };
              //   })
              //   .reduce((all, item) => all.concat(item.items), [])
              //   .sort((a, b) => new Date(b.pa || b.dpa) - new Date(a.pa || a.dpa));
              // console.log('trending', trending);
              // dispatch('watchlistTrending', trending);
            },
            async fetchFeedJson(store, value) {
              //const url = `https://api.weave.ai/cs/manifests/${value}.json`;
              //await dispatch('addLoader');
              // console.log('fetching fetchFeedJson', value);
              let json;
              try {
                const response = await fetch(value);
                json = Object.freeze((await response.json()) || {});
                // console.log('fetched fetchFeedJson', value);
              } catch (ex) {
                console.log('failed fetchFeedJson', value, ex.message);
              }
              //await dispatch('folderLiteCache', { ...folderLiteCache, [value]: json });
              //console.log('fetched folderLite', value);
              return { json };
            },
            async loadFolderLite(
              {
                dispatch,
                commit,
                getters: { folderLiteCache }
              },
              value
            ) {
              const url = `https://api.weave.ai/cs/lite/manifests/${ value }.json`;
              //await dispatch('addLoader');
              //console.log('fetching folderLite', value);
              const response = await fetch(url);
              const json = Object.freeze((await response.json()) || {});
              //await dispatch('folderLiteCache', { ...folderLiteCache, [value]: json });
              //console.log('fetched folderLite', value);
              return { value, json };
              const {
                topDocs,
                themes,
                script: { title }
              } = json;
              Object.values(docs).forEach(doc => {
                doc.th = (doc.thi || []).map(({ i }) => {
                  const t = { ...themes[i].th, c: themes[i].c };
                  return t.n;
                });
                doc.themes = (doc.thi || []).reduce((all, thi, i) => {
                  all[doc.th[i]] = thi;
                  return all;
                }, {});
                doc.tg = [].concat(
                  ...(doc.thi || []).map(({ i }) => {
                    const t = { ...themes[i].th, c: themes[i].c };
                    return t.k;
                  })
                );
              });
              dispatch('folderList', docs);
              const thms = Object.freeze(
                Object.values(themes)
                  .map(({ th, c }) => ({ ...th, c }))
                  .sort((a, b) => b.c - a.c)
                  .reduce((all, th) => {
                    //console.log(th.n, th.c);
                    all[th.n] = th;
                    return all;
                  }, {})
              );
              //console.log('thms', JSON.stringify(thms, null, 2));
              dispatch('themes', thms);
              const folderTitle = 'Weave - ' + title;
              document.title = folderTitle;
              dispatch('title', folderTitle);
              dispatch('loadedTitle', folderTitle);
              //const { Result: results, Message: message = 'small doco no results' } = json || {};
              await dispatch('removeLoader');
            },
            async loadFolder(
              {
                dispatch,
                getters: { robo }
              },
              value
            ) {
              const url = `https://api.weave.ai/cs/manifests/${ value }.json`;
              await dispatch('addLoader', 'loadFolder');
              console.log('fetching folder?', value);
              const response = await fetch(url);
              const json = Object.freeze((await response.json()) || {});
              const {
                docs,
                themes,
                script: { title },
                publishers,
                analytics
              } = json;
              if (robo && analytics) {
                await dispatch('morphAnalytics', { folderAnalytics: analytics, themes });
                // dispatch('folderAnalytics', Object.freeze(analytics));
              }
              Object.values(docs).forEach(doc => {
                doc.th = (doc.thi || []).map(({ i }) => {
                  const t = { ...themes[i].th, c: themes[i].c };
                  return t.n;
                });
                doc.themes = (doc.thi || []).reduce((all, thi, i) => {
                  all[doc.th[i]] = thi;
                  return all;
                }, {});
                doc.tg = [].concat(
                  ...(doc.thi || []).map(({ i }) => {
                    const t = { ...themes[i].th, c: themes[i].c };
                    return t.k;
                  })
                );
              });
              if (publishers) {
                dispatch('folderPublishers', Object.freeze(publishers));
              }
              dispatch('folderList', docs);
              await dispatch('morphThemes', { folderThemes: themes });
              /*
              const thms = Object.freeze(Object.values(themes).map(({ th, c }) => ({ ...th, c })).sort((a, b) => b.c - a.c).reduce((all, th) => {
                    //console.log(th.n, th.c);
                    all[th.n] = th;
                    return all;
                  }, {}));
              //console.log('thms', JSON.stringify(thms, null, 2));
              dispatch('themes', thms);
               */
              const folderTitle = 'Weave - ' + title;
              document.title = folderTitle;
              dispatch('title', folderTitle);
              dispatch('loadedTitle', folderTitle);
              //const { Result: results, Message: message = 'small doco no results' } = json || {};
              await dispatch('removeLoader');
            },
            async loadEngage(
              {
                dispatch //,
                //getters: { }
              },
              value
            ) {
              const url = `https://api.weave.ai/cs/engage/manifests/${ value }.json`;
              await dispatch('addLoader', 'loadEngage');
              console.log('fetching engage?', value);
              const response = await fetch(url);
              const json = Object.freeze((await response.json()) || {});
              const {
                // docs,
                // themes,
                // analytics,
                data,
                script: { banner, title, publisherIds = [], sections, exitSections, tickers, subjectThemes, auth, domains, spotlightInfo }
              } = json;
              const { publishers, fundInfo, scenes, subsections, notifications } = data;
              const { access = '', userTypes } = auth || {};
              const [publisherId] = publisherIds;
              console.log('loadEngage', publisherIds, publishers, banner, 'gated', /gated/.test(access));
              const gated = /gated/.test(access);
              if (gated) {
                const { setTimeout } = window;
                let checkedForFavorite;
                // const initialDelay = 3 * 60 * 1000;
                const initialDelay = 0.1 * 60 * 1000;
                const delay = 15000;
                console.log('userTypes', userTypes);
                const check = () => {
                  const { g } = window;
                  console.log('auth check', initialDelay, g?.authStatus, g?.authStatuses?.[g?.authStatus] || 'anonymous');
                  if (g?.authStatus === 'h' && !checkedForFavorite) {
                    // (async () => {
                      // const response = await fetch('https://h.weave.ai/api/chfollow?w=${ value }&m=1`');
                      // const json = Object.freeze((await response.json()) || {});
                    // })();

                  }
                  setTimeout(check, delay);
                };
                setTimeout(check, initialDelay);
              }
              if (banner) {
                let themes;
                if (subjectThemes) {
                  themes = subjectThemes.reduce((all, t) => {
                    all[t] = true;
                    return all;
                  }, {});
                }
                await dispatch('engage', Object.freeze({ banner: (themes && { ...banner, themes }) || banner, publisher: { ...publishers[publisherId], key: publisherId }, ...data, sections, exitSections, ticker: tickers[0], fund: fundInfo, scenes, subsections, notifications, domains: Object.freeze(domains || []), spotlightInfo: Object.freeze(spotlightInfo || {}) }));
                (async () => {
                  const response = await fetch(`https://api.weave.ai/cs/engage/spotlight/manifests/${ value }.json`);
                  try {
                    const json = Object.freeze((await response.json()) || {});
                    const spotlight = Object.entries(json.spotlightTable).reduce((all, [k, v]) => {
                      all[k] = Object.entries(v.spotlightThemesTable).filter(([_, t]) => Object.values(t).some(v => v)).reduce(entriesToObject, {});
                      return all;
                    }, {});
                    await dispatch('spotlight', Object.freeze(spotlight));
                    console.log('spotlight', spotlight);
                  } catch (ex) {}
                })();
              }
              if (publishers) {
                const otherPubs = { ...publishers };
                delete otherPubs[publisherId];
                await dispatch('engagePublishers', Object.freeze(otherPubs));
                await dispatch('engageShown', true);
              }
              // dispatch('folderList', docs);
              // await dispatch('morphThemes', { folderThemes: themes });
              /*
              const thms = Object.freeze(Object.values(themes).map(({ th, c }) => ({ ...th, c })).sort((a, b) => b.c - a.c).reduce((all, th) => {
                    //console.log(th.n, th.c);
                    all[th.n] = th;
                    return all;
                  }, {}));
              //console.log('thms', JSON.stringify(thms, null, 2));
              dispatch('themes', thms);
               */
              const engageTitle = 'Weave - ' + title;
              document.title = engageTitle;
              dispatch('title', engageTitle);
              dispatch('loadedTitle', engageTitle);
              //const { Result: results, Message: message = 'small doco no results' } = json || {};
              await dispatch('removeLoader', 'loadEngage');
            },
            async loadInsights(
              {
                dispatch,
                commit,
                //getters: { insightsCache, folderList }
                getters: { folderList, robo }
              },
              { id = '', pages = [] }
            ) {
              console.log('load insights', id);
              let result;
              try {
                // todo: this caches at the doc level but the pages could change
                //let result;// = insightsCache[id];
                if (!result) {
                  console.log('load insights 2', id, pages);
                  await dispatch('roboFetching', true);
                  const pgs = (pages.length && '&pages=' + pages.join('|')) || '';
                  //const response = await fetch(`https://d1l6gufwe1p5x2.cloudfront.net/api/topoqa/getdocinsightsbyid?id=${ id }&pages=1|3|4|5|7`);
                  const response = await fetch(
                    ((folderList || robo) && `https://api.weave.ai/cs/cache/docs/insights/${ id }.json`) ||
                    `https://d1l6gufwe1p5x2.cloudfront.net/api/topoqa/getdocinsightsbyid?id=${ id }${ pgs }`
                  );
                  const json = await response.json();
                  result = json.Result || json;
                  console.log('loaded insights result', result);
                  commit('addInsights', { ...result, id });
                }
                return result.kts;
              } catch (ex) {
                console.log('load insights fail', ex, result);
              } finally {
                await dispatch('roboFetching', false);
              }
            },
            async loadDoco(
              {
                dispatch,
                commit,
                getters: { readingList, lens, folderList, backToRobo, robo }
              },
              doco = ''
            ) {
              console.log('load doco', doco);
              try {
                commit('doco', doco);
                await dispatch('addLoader');
                if (!folderList) {
                  await dispatch('selectedThemes', {});
                }
                console.log('fetching doco', doco);
                const useCache = /\bchc\b/.test(location.hash || '');
                let json = localJSON;
                if (!json) {
                  json = (window.docoCache || {})[doco];
                }
                if (!json) {
                  //const response = await fetch(`https://topoqa.azurewebsites.net/api/topoqa/getdocbyidv2?id=${ doco }`);
                  const response = await fetch(
                    ((folderList || robo || useCache) && `https://api.weave.ai/cs/cache/docs/manifests/${ doco }.json`) ||
                    `https://d1l6gufwe1p5x2.cloudfront.net/api/topoqa/getdocbyidv2?id=${ doco }`
                  );
                  json = await response.json();
                }
                //const response = await fetch('https://d2y6xbewdq0tk3.cloudfront.net/doco/Technology.json', {
                // const response = await fetch(`https://topoqa.azurewebsites.net/api/topoqa/getdocbyid?id=${ doco }`);
                // const json = await response.json();
                const { pgs, tht: aliases, tst, di } = json || {};
                console.log('loadDoco', di);
                dispatch('docoJSON', Object.freeze(json));
                //console.log('main 2', normalize(aliases));
                if (pgs?.length) {
                  window.docoCache = window.docoCache || {};
                  window.docoCache[doco] = window.docoCache[doco] || json;
                  //pgs.forEach(item => (item.selected = 'selected' in item ? item.selected : true));
                  pgs.forEach(item => dispatch('selectDoc', { item, select: true }));
                  dispatch('documents', pgs);
                  if (lens && !folderList) {
                    dispatch('docoThemes', Object.freeze(tst));
                  }
                  if (lens) {
                    dispatch('docoInsights', Object.freeze(di));
                    //dispatch('pdf', doco);
                  }
                  dispatch('docoPublisher', { logo: json.simgu, name: json.st });
                  const { t: docoTitle } = pgs[0];
                  const title = 'Weave Doc Nav - ' + docoTitle;
                  if (!folderList && !backToRobo) {
                    window.scrollTo(0, 0);
                    document.title = title;
                  }
                  // todo: listen to popState?
                  if (!readingList?.[0] && !folderList && !backToRobo && !useCache) {
                    console.log('nav?', backToRobo, useCache);
                    history.replaceState({}, title, '?' + doco + location.hash && `#${ location.hash }`);
                  }
                  dispatch('title', docoTitle);
                  //dispatch('scenes', scenes);
                  if (aliases) {
                    await dispatch('aliases', normalize(aliases));
                  }
                  await dispatch('pdfView', false);
                  clearTimeout(pdfTimer);
                  pdfTimer = setTimeout(async () => {
                    console.log('pdfTimer fired', doco);
                    await dispatch(
                      'pdf',
                      `https://content.weave.ai/documents/${ doco }${ (pgs.length > 1 && '-1') || '' }.pdf`
                    );
                  }, 1000);
                }
              } catch (ex) {
                console.log('error in main', ex);
              } finally {
                setTimeout(() => dispatch('removeLoader'), 1000);
              }
              function normalize(aliases) {
                //console.log(Object.entries(aliases || {}).length, 5893);
                return Object.entries(aliases).reduce((all, [key, value]) => {
                  return { ...all, [key]: [key, ...value].join('|') /*.toLowerCase()*/ };
                }, {});
              }
            },
            docSort(
              {
                commit,
                dispatch,
                getters: { documents }
              },
              value
            ) {
              commit('docSort', value);
              const comparers = {
                ascending(a, b) {
                  return a.pgn - b.pgn;
                },
                descending(a, b) {
                  return b.pgn - a.pgn;
                },
                relevance(a, b) {
                  return b.rel - a.rel;
                },
                ['visual interest'](a, b) {
                  return b.vis - a.vis;
                }
              };
              dispatch('documents', [...documents].sort(comparers[value]));
            },
            topos({ commit }, { keyword_indices, entries }) {
              commit('topos', {
                keyword_indices,
                entries: entries.map(entry => ({ ...entry, id: (/\?(.+)$/.exec(entry.url) || [])[1], type: 'topo' }))
              });
            },
            async tickers({ commit }) {
              const response = await fetch('https://s3-us-west-2.amazonaws.com/weave.ai/data/tickermapinfo.json');
              const { tickerSymbolTable: symbols } = await response.json();
              commit('tickersMap', symbols);
              commit(
                'tickers',
                Object.entries(symbols).map(([ticker, name]) => {
                  return { id: ticker, title: name, type: 'ticker', search: [ticker, name].join('|') };
                })
              );
            },
            toggleTicker({ commit }, value) {
              commit('toggleTicker', value);
            },
            selectSource({ commit }, value) {
              console.log('selectSource', JSON.stringify(value, null, 2));
              commit('selectSource', value);
              fetchMedia(store());
            },
            addLoader({ commit, getters }, options = {}) {
              console.log('addLoader', options);
              const { delay = 1.5, autoClear = 30 } = options;
              commit('loader', true);
              clearTimeout(clearLoaderTimer);
              clearLoaderTimer = setTimeout(() => {
                console.log('addLoader removeLoader timer', options, 'loader', getters.loader || 'already cleared');
                commit('loader', true);
                clearLoaderTimer = setTimeout(() => commit('loader', false), autoClear * 1000);
              }, delay * 1000);
            },
            removeLoader({ commit }, from) {
              console.log('removeLoader', from);
              clearTimeout(clearLoaderTimer);
              commit('loader', false);
            },
            currentDocument(
              {
                commit,
                dispatch,
                getters: { currentDocument }
              },
              value
            ) {
              if (currentDocument !== value) {
                commit('currentDocument', value);
                dispatch('currentPage', null);
              }
            },
            async fetchMedia(s, value) {
              return await fetchMedia(store(), value);
            },
            collapse({ commit }, value) {
              Vue.cookie[(value && 'set') || 'delete']('collapse', value);
              commit('collapse', value);
            },
            facetsCollapsed({ commit }, value) {
              Vue.cookie[(value && 'set') || 'delete']('facetsCollapsed', value);
              commit('facetsCollapsed', value);
            },
            widerInsights({ commit }, value) {
              Vue.cookie[(value && 'set') || 'delete']('widerInsights', value);
              commit('widerInsights', value);
            }
          },
          getters: {
            // insightsShown({ insightsShown }, { focusMode }) {
            //   return (insightsShown === null && focusMode) || insightsShown;
            // },
            /*insightsThemesShown({ insightsThemesShown }, { focusMode }) {
              return focusMode || insightsThemesShown;
            },*/
            au({ auDate }) {
              return auDate && getAu();
            },
            authLp() {
              // todo: remove replace for prod
              return licensePlate().replace(/^\w{3}/, 'tes');
            },
            authStatuses() {
              return {
                n: 'shown',
                d: 'scanned',
                i: 'input',
                t: 'sent',
                h: 'auth'
              };
            },
            authStatusLabel(state, { authStatus, authStatuses }) {
              return authStatuses[authStatus] || '';
            },
            // todo: getter for title
            engagePubContext({ engagePubContext }, { engageFilteredPublishers }) {
              return engagePubContext === 'engageFilteredPublishers' ? engageFilteredPublishers.reduce((map, item) => {
                map[item.id] = item;
                return map;
              }, {}) : engagePubContext;
            },
            engageHoldingsGroupedByTicker(state, { engageFullHoldings: fullHoldings }) {
              console.log('engageHoldingsGroupedByTicker getter', fullHoldings);
              return fullHoldings && Object.entries(fullHoldings).reduce((map, [t, h]) => {
                //const time = new Date(h.dt);
                const time = new Date(t * 1000);
                h.holdings.forEach(({ t: ticker, p: percent }) => {
                  map[ticker] = map[ticker] || [];
                  //console.log(ticker, t);
                  map[ticker].push({ ticker, percent, time, td: h.dt });
                });
                return map;
              }, {});
            },
            engageMaxAges() {
              return ['last quarter', 'last two quarters', 'last year', 'last two years', 'last five years'];
            },
            engageNextMaxAge(state, { engageMaxAge: ema, engageMaxAges: emas }) {
              return emas[emas.findIndex(item => item === ema) + 1] || emas[0];
            },
            engageMaxAgeNumber(state, { engageMaxAge }) {
              return {
                'last quarter': 93, 'last two quarters': 186, 'last year': 365, 'last two years': 730, 'last five years': 1825
              }[engageMaxAge];
            },
            engageRegions() {
              return {
                na: 'North America',
                la: 'Latin America',
                uk: 'United Kingdom',
                ed: 'Europe Developed',
                ee: 'Europe Emerging',
                am: 'Africa/Middle East',
                jp: 'Japan',
                au: 'Australasia',
                ad: 'Asia Developed',
                ae: 'Asia Emerging'
              };
            },
            engageFilteredPublishers(state, { engage: { scenes }, engageSection: { earningInsights: { publishers = [] } = {} }, styleFilter: sf = '', dividendOnly: pays, engageNewOnly: newOnly, engageSelectedRegions: regions, engageSelectedSectors: sectors }) {
              //const size = sf.replace(/\|.+$/, '');
              //const kind = sf.replace(/^.+\|/, '');
              const hasRegions = Object.keys(regions).length;
              const hasSectors = Object.keys(sectors).length;
              return (
                ((sf || pays || newOnly || hasRegions || hasSectors) &&
                  publishers.reduce((all, pub) => {
                    const { id: key } = pub;
                    const { stockMetadata = {} } = scenes[key] || {};
                    const {
                      style,
                      fundHoldingInfo: { paysDividend, isNew },
                      region,
                      sector
                    } = stockMetadata;
                    //console.log('engageFilteredPublishers', key, sector);
                    if (
                      //(!sf || style.toLowerCase() === sf.replace(/\|/, ' cap '))
                      styleMatches(style) &&
                      (!pays || paysDividend) &&
                      (!newOnly || isNew) &&
                      (!hasRegions || regions[region]) &&
                      (!hasSectors || sectors[sector])
                    ) {
                      all.push(pub);
                    }
                    return all;
                  }, [])) ||
                publishers
              );
              function styleMatches(style = '') {
                const noFilter = !sf;
                const hasWild = /\*/.test(sf);
                let r = noFilter;
                if (!r) {
                  if (hasWild) {
                    console.log('hasWild', style, sf);
                    const wildSize = /^\*\|/;
                    if (wildSize.test(sf)) {
                      r = style.toLowerCase().replace(/(?:small|mid|large) cap /, '') === sf.replace(wildSize, '');
                    } else {
                      r = style.toLowerCase().replace(/ cap (?:value|core|growth)/, '') === sf.replace(/\|\*$/, '');
                    }
                  } else {
                    r = style.toLowerCase() === sf.replace(/\|/, ' cap ');
                  }
                }
                return r;
              }
            },
            engageSection(state, { engage, engageSelectedSection: selected, engagePublishers: publishers }) {
              const { videos = {}, sections = [], subsections = {}, themesMetadata: { themes } = {} } = engage || {};
              const section = (sections.find(({ title }) => title === selected) || {});
              const r = {
                ...section,
                get videos() {
                  const subsection = (section.subsections?.filter(({ primaryType: pt }) => pt === 'Videos') || [])[0] || {};
                  const { videoIds } = subsections[subsection.id] || {};
                  // console.log('engage getter videos', videos, videoIds);
                  return { ...subsection, items: videoIds?.split(/\|/)?.map((id) => videos[id]) || [] };
                },
                get docInsights() {
                  const subsection = (section.subsections?.filter(({ widgetName: n }) => n === 'Document Insights') || [])[0] || {};
                  return { ...subsection, documents: subsection?.documentsData?.documents };
                },
                get earningInsights() {
                  const subsection = (section.subsections?.filter(({ secondaryTypes: st }) => (st || []).includes('Earnings Insights')) || [])[0] || {};
                  return { ...subsection, publishers: subsection?.publisherIds?.filter(id => publishers[id]).map(id => publishers[id]) };
                },
                get themesInsights() {
                  const subsection = (section.subsections?.filter(({ widgetName: n }) => n === 'Theme Insights') || [])[0] || {};
                  //console.log('themesInsights getter watcher2', subsection, subsection?.themes?.filter(id => themes[id]).map(id => themes[id]));
                  return { ...subsection, themes: subsection?.themes?.filter(id => themes[id]).map(id => themes[id]) };
                },
                get insights() {
                  const subsection = (section.subsections?.filter(({ widgetName: pt }) => pt === 'Insights') || [])[0] || {};
                  return { ...subsection };
                }
              };
              return r;
            },
            engagePlaylist(state, { engage }) {
              const { masterPlaylistVideoIds, videos } = engage || {};
              return engage && (masterPlaylistVideoIds.join && masterPlaylistVideoIds.join('|') || masterPlaylistVideoIds).split(/\|/).map(id => videos[id]);
            },
            engageBap(state, { engage: { publishers, scenes } = {}, engagePlaylist, currentVideo }) {
              const pubId = currentVideo?.sc?.[0] || engagePlaylist[0]?.sc?.[0];
              const reportCard = scenes[pubId]?.reportCards?.[0];
              const pub = publishers?.[pubId];
              let r;
              if (pub) {
                r = { ...pub, reportCard };
              }
              return r;
            },
            refPubInfo(
              state,
              {
                watchlistThemesRefPub: refPub,
                industry,
                watchlistPublishers: publishers,
                analytics,
                watchlistThemesParentFilter,
                themes
              }
            ) {
              const pt = analytics?.thd?.pt;
              // console.log('refPubInfo getter', pt);
              const theme = watchlistThemesParentFilter && { ...(themes[watchlistThemesParentFilter] || {}) };
              let performance;
              if (theme) {
                theme.ps = morphedPS(theme.ps);
                performance = theme.ps.find(({ key }) => key === refPub);
                if (performance) {
                  performance.label = performanceLabel(performance);
                }
              }
              return refPub && pt && { ...publishers[refPub], key: refPub, industry, theme, performance };
              function performanceLabel({ cpr }) {
                // 'very poorly'() {
                return (
                  (cpr <= 25 && 'very poor') ||
                  (cpr <= 50 && 'poor') ||
                  (cpr >= 75 && 'very good') ||
                  (cpr >= 50 && 'good')
                );
              }
              function morphedPS(ps) {
                return Object.entries(ps || {})
                  .reduce((all, [i, v]) => {
                    const key = pt[i];
                    all.push({ ...(publishers[key] || {}), key, ...(v || {}) });
                    return all;
                  }, [])
                  .sort((a, b) => a.cr - b.cr);
              }
            },
            industry({ industry }, { primaryThemeConcept }) {
              return industry || primaryThemeConcept;
            },
            roboReportUrl(
              state,
              {
                childThemes,
                topParentThemes,
                roboReportThemesSize,
                publishers,
                selectedWatchlistThemes,
                watchlistThemesAndOr,
                selectedWatchlistPublishers,
                selectedWatchlistDocTypes,
                watchlistThemesShown,
                watchlistCurrency,
                watchlistNumeric,
                roboReportShown,
                roboReportStartTime,
                roboReportEndTime
              }
            ) {
              // const thms = ['3G', '5G', 'Internet'] || childThemes.map(({ n }) => n) ||  topParentThemes;
              const thms = childThemes?.map(({ n }) => n) || topParentThemes?.map(([n]) => n) || [];
              // s=0&c=200&
              let custom = (roboReportShown && watchlistThemesShown) || '';
              const currency = (custom && watchlistCurrency && '&hm=true') || '';
              const numeric = (custom && watchlistNumeric && '&hn=true') || '';
              const andOr = (custom && watchlistThemesAndOr && '&to=AND') || '';
              // todo: make dynamic
              const quarters =
                (custom &&
                  (roboReportStartTime || roboReportEndTime) &&
                  `&qr=${ roboReportStartTime || 14.4 }-${ roboReportEndTime || 21.2 }`) ||
                '';
              custom = custom && currency + numeric + andOr + quarters;
              const th = (
                (custom && Object.keys(selectedWatchlistThemes)) ||
                thms.filter((k, i) => i < roboReportThemesSize)
              ).join('|');
              console.log('roboReport url getter');
              const selectedWatchlistPublishersLength = Object.keys(selectedWatchlistPublishers || {}).length;
              const pu = Object.keys((custom && selectedWatchlistPublishersLength && selectedWatchlistPublishers) || publishers || {}).join('|');
              // console.log('custom pubs', custom, publishers, Object.keys((custom && selectedWatchlistPublishersLength && selectedWatchlistPublishers) || publishers || {}));
              const dtk = Object.keys(selectedWatchlistDocTypes || {});
              const dt = (custom && dtk.length && '&ty=' + dtk.join('|')) || '';
              return `https://dsgt1uxjkh3a.cloudfront.net/api/QueryInsightsDb?th=${ th }&pu=${ pu }${ custom }${ dt }&ik=1`;
              // const url = `https://queryinsightsdb20201022201232.azurewebsites.net/api/QueryInsightsDb?th=${ thms.filter((k, i) => i < roboReportThemesSize).join('|') }`;
            },
            engageRoboReportUrl(
              state,
              {
                // publishers,
                engageSection,
                engageSelectedDocuments,
                engageSelectedPublishers,
                engageMaxAgeNumber,
                engageSelectedThemes,
                engageKeywords,
                // todo: change this to engage specific
                selectedWatchlistDocTypes,
                engageInsightsCategory,
                engageAndOr
                // selectedWatchlistPublishers
              }
            ) {
              // const selectedWatchlistPublishersLength = Object.keys(selectedWatchlistPublishers || {}).length;
              // const pu = Object.keys((custom && selectedWatchlistPublishersLength && selectedWatchlistPublishers) || publishers || {}).join('|');
              // console.log('custom pubs', custom, publishers, Object.keys((custom && selectedWatchlistPublishersLength && selectedWatchlistPublishers) || publishers || {}));
              const di = engageSection?.docInsights;
              const ti = engageSection?.themesInsights;
              const publishers = di?.documentsData?.publisherIds || ti?.publisherIds || engageSection.earningInsights?.publishers?.map(({ id }) => id);
              const selectedDocuments = Object.keys(engageSelectedDocuments);
              const dids = (selectedDocuments.length && selectedDocuments || di?.documents?.map(({ id }) => id))?.join('|');
              const selectedPublishers = Object.keys(engageSelectedPublishers);
              const pu = (selectedPublishers.length && selectedPublishers || publishers)?.join('|');
              const selectedThemes = Object.keys(engageSelectedThemes);
              const th = (selectedThemes.length && `&th=${ (selectedThemes || [])?.join('|') }` || '') || '';
              const kw = (engageKeywords?.trim().length && `&kw=${ engageKeywords.trim().replace(/\s+/g, '|') }` || '') || '';
              const ca = (engageInsightsCategory && `&ca=${ engageInsightsCategory }`) || '';
              const ao = (engageAndOr !== 'or' && `&to=${ engageAndOr.toUpperCase() }`) || '';
              //console.log('th', th);
              let sWDT = Object.keys(selectedWatchlistDocTypes);
              //const ty = sWDT.length === 1;
              const hasFilters = engageSection && !engageSection.subsections?.some(s => s.sourceType === 'Documents');
              const docTypes = engageSection?.subsections?.find(({ docTypes }) => docTypes)?.defaultDocTypes || { wt: true, ect: true };
              // console.log('sWDT...', sWDT);
              if (sWDT.length) {
                sWDT = sWDT.filter(w => docTypes.includes(w));
              }
              // console.log('...sWDT', sWDT, docTypes);
              const defaultDocTypes = engageSection?.subsections?.find(({ defaultDocTypes }) => defaultDocTypes)?.defaultDocTypes || ['wt', 'ect'];
              return `https://dsgt1uxjkh3a.cloudfront.net/api/QueryInsightsDb?ik=1&pu=${ pu }${ dids && `&did=${ dids }` || '' }${ hasFilters && `&ty=${ (sWDT.length && sWDT || defaultDocTypes).join('|') }`  || '' }${ (hasFilters && `&ma=${ engageMaxAgeNumber }`) || '' }${ th }${ kw }${ ca }${ ao }`;
              // return `https://dsgt1uxjkh3a.cloudfront.net/api/QueryInsightsDb?${ dids && `did=${ dids }` || '' }`;
              // const url = `https://queryinsightsdb20201022201232.azurewebsites.net/api/QueryInsightsDb?th=${ thms.filter((k, i) => i < roboReportThemesSize).join('|') }`;
            },
            docoPublisher(
              { docoPublisher },
              { folderList, folderPublishers, roboPublishers, watchlistPublishers, roboWeaveShown, watchlistShown }
            ) {
              return (!folderList && !roboWeaveShown && !watchlistShown && docoPublisher) || null;
            },
            watchlistThemesRefPubSentiment({ watchlistThemesRefPubSentiment: sentiment }, { watchlistThemesHoverRefPubSentiment: hoverSentiment }) {
              return hoverSentiment || sentiment || null;
            },
            hoverPub({ hoverPub }, { referencePub }) {
              return (!referencePub && hoverPub) || null;
            },
            referencePub({ referencePub }, { publishers }) {
              return (publishers[referencePub] && referencePub) || null;
            },
            publishers(
              state,
              { folderPublishers, roboWeaveShown, roboPublishers, watchlistShown, watchlistPublishers, engageShown, engagePublishers }
            ) {
              return (engageShown && engagePublishers) || (watchlistShown && watchlistPublishers) || (roboWeaveShown && roboPublishers) || folderPublishers;
            },
            analytics({ analytics }, { folderAnalytics, roboWeaveShown, watchlistShown, watchlistAnalytics, engageShown }) {
              return ((engageShown || watchlistShown) && watchlistAnalytics) || (roboWeaveShown && analytics) || folderAnalytics;
            },
            // watchlist({ watchlist }) {
            // },
            childThemes(_, { selectedParentTheme, themes, analytics, hoverPub, referencePub, leadingTrailing }) {
              const ct = themes[selectedParentTheme]?.cth?.map(({ n }) => themes[n]).filter(theme => theme);
              const rsps = ct?.reduce(themeTotalRsp, {});
              let sorter = (a, b) => rsps[b.n] - rsps[a.n];
              const map = analytics.thd.tht;
              if (referencePub) {
                const pgr = ({ n }) => map[n]?.pwt?.[referencePub]?.pgr || 0;
                sorter = (leadingTrailing && ((a, b) => pgr(b) - pgr(a))) || ((a, b) => pgr(a) - pgr(b));
              }
              return ct?.sort(sorter);
              function themeTotalRsp(all, { n }) {
                //console.log('n', n, all);
                all[n] = Object.values((analytics.thd.tht[n] || {}).pwt).reduce(
                  (total, { wt }) => total + ((hoverPub && totalRpst) || totalRsp)(wt),
                  0
                );
                return all;
                function totalRpst(wt) {
                  return Object.values(wt).reduce((total, { rpst }) => total + rpst * 1, 0);
                }
                function totalRsp(wt) {
                  return Object.values(wt).reduce((total, { rsp }) => total + rsp * 1, 0);
                }
              }
            },
            watchlistThemesForPickerMax(state, { watchlistThemesForPickerNoa: noa }) {
              return Math.max.apply(null, noa.map(([_, { c }]) => c));
            },
            watchlistThemesForPickerNoa(state, { themes }) {
              return Object.entries(themes).filter(([_, { a }]) => !a);
            },
            watchlistThemesForPicker(state, { watchlistThemesForPickerNoa: noa }) {
              const l = noa.length;
              const t = total(noa);
              const average = t / l;
              const aboveAverage = noa.filter(([_, { c }]) => c > average);
              // return { aboveAverage, l, t, a, n };
              //console.log('aboveAverage sorted', aboveAverage.sort((a, b) => b[0] - a[0]));
              return (
                aboveAverage
                  /*.sort((a, b) => {
                  let r = 0;
                  if (a[0] < b[0]) {
                    r = -1;
                  }
                  if ( a[0] > b[0]) {
                    r = 1;
                  }
                  return r;
                })*/
                  .reduce((all, [key, value], index) => {
                    if (index < 400) {
                      all[key] = value;
                    }
                    return all;
                  }, {})
              );
              function total() {
                return noa.reduce((total, [_, { c }]) => total + c, 0);
              }
            },
            insightsWordCounts(state, { docoInsights }) {
              //console.log('insightsWordCounts', docoInsights || 'no di');
              // todo: move this into insights.vue and use items as the base
              const r =
                (docoInsights?.kts &&
                  Object.entries(
                    docoInsights.kts.reduce((all, kt) => {
                      Object.entries(tallyWords(kt)).forEach(([k, count]) => {
                        all[k] = all[k] || 0;
                        all[k] += count;
                      });
                      return all;
                    }, {})
                  )
                    .sort((a, b) => b[1] - a[1])
                    .filter((_, i) => i < 50)) ||
                [];
              const counts = r.map(([_, c]) => c);
              r.maxValue = Math.max.apply(null, counts);
              r.minValue = Math.min.apply(null, counts);
              r.medianValue = counts.reduce((total, c) => total + c) / counts.length;
              return r;
              function tallyWords({ h }) {
                return (
                  h?.split(/\|/).reduce((all, word) => {
                    all[word] = all[word] || 0;
                    all[word]++;
                    return all;
                  }, {}) || {}
                );
              }
            },
            topParentThemes(state, { analytics, themes, hoverPub, referencePub, leadingTrailing }) {
              const { tht } = analytics?.thd || {};
              return (
                (Object.keys(analytics || {}).length &&
                  Object.keys(themes || {}).length &&
                  Object.entries(analytics?.thd?.tht)
                    .filter(([key]) => themes[key]?.cth)
                    .filter((_, index) => index < 40)
                    .map(([key, { pwt: pubs }]) => [
                      key,
                      referencePub
                        ? pubs[referencePub]?.pgr || 0
                        : Object.values(pubs).reduce(
                          (total, { wt }) => total + ((hoverPub && totalRpst) || totalRsp)(wt, key),
                          0
                        )
                    ])
                    .sort(
                      (referencePub && !leadingTrailing && (([_, a], [$, b]) => a - b)) || (([_, a], [$, b]) => b - a)
                    )) ||
                []
              );
              function totalRpst(wt) {
                return Object.values(wt).reduce((total, { rpst }) => total + rpst * 1, 0);
              }
              function totalRsp(_, key) {
                //console.log('totalRsp', key, tht || 99, analytics?.thd || 88);
                return tht?.[key]?.thw?.rs || 0;
              }
            },
            selectedInsightsThemes({ selectedInsightsThemes }, { insightsThemes }) {
              return Object.entries(selectedInsightsThemes)
                .filter(([n]) => insightsThemes[n])
                .reduce((all, [k, v]) => {
                  all[k] = v;
                  return all;
                }, {});
            },
            selectedInsightsThemesKeywords(state, { selectedInsightsThemes, insightsThemes }) {
              return Object.keys(selectedInsightsThemes).reduce((all, t) => {
                all[t] = insightsThemes[t]?.k || [t];
                return all;
              }, {});
            },
            insightsThemes(state, { entry, themes = {}, insightsThemesParentFilter }) {
              const parentTheme = themes[insightsThemesParentFilter];
              return (
                entry?.kts &&
                Object.entries(
                  entry.kts.reduce((all, { th }) => {
                    th?.forEach(t => {
                      if (
                        !parentTheme ||
                        t === insightsThemesParentFilter ||
                        parentTheme?.cth.map(({ n }) => n).includes(t)
                      ) {
                        all[t] = all[t] || 0;
                        ++all[t];
                      } else {
                        //console.log('insightsThemes unknown theme', t);
                      }
                    });
                    return all;
                  }, {})
                )
                  .sort(([key1, a], [key2, b]) => b - a)
                  .reduce((all, [key, value]) => {
                    all[key] = { n: key, t: key, ...(themes[key] || { local: true }), count: value };
                    return all;
                  }, {})
              );
            },
            trendingVideos(state, { trending, watchlistShown, watchlistTrending }) {
              return watchlistShown && watchlistTrending || trending?.filter(({ type }) => type === 'video');
            },
            watchlistTrendingVideos(state, { watchlistTrending }) {
              return watchlistTrending?.filter(({ type }) => type === 'video');
            },
            trending({ trending }, { roboNotificationsFilter = '' }) {
              const words = roboNotificationsFilter.split(' ').map(word => new RegExp(escapeRegExp(word), 'i'));
              return roboNotificationsFilter && trending.filter(({ t = '', st = '', d = '' }) => words.every(w => w.test([t, st, d].join('|')))) || trending;
              function escapeRegExp(s) {
                return `${ s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }`; // $& means the whole matched string
              }
            },
            watchlistTrending({ watchlistTrending }, { watchlistNotificationsFilter = '' }) {
              const words = watchlistNotificationsFilter.split(' ').map(word => new RegExp(escapeRegExp(word), 'i'));
              return watchlistNotificationsFilter && watchlistTrending.filter(({ t = '', st = '', d = '' }) => words.every(w => w.test([t, st, d].join('|')))) || watchlistTrending;
              function escapeRegExp(s) {
                return `${ s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }`; // $& means the whole matched string
              }
            },
            skimmerSort({ skimmerSort }, { selectedThemes }) {
              return skimmerSort || (Object.keys(selectedThemes).length && 'Weight') || 'age';
            },
            folderPages(state, { folderList, folderDoco, entry }) {
              const { kts } = entry || {};
              const { ds } = folderList?.[folderDoco] || {};
              const pgc = ds?.pgc;
              const withInsights = kts?.reduce((withInsights, { p }) => {
                withInsights[p] = true;
                return withInsights;
              }, {});
              //const
              return folderList && Object.keys(withInsights);
            },
            entry(state, { insightsDoco, insightsCache, selectedThemes, customThemes, folderList, docoInsights }) {
              //const { insightsDoco, insightsCache, selectedThemes, customThemes } = this;
              let r = (insightsCache || {})[insightsDoco];
              if (false && folderList) {
                //const length = Object.keys(selectedThemes).length;
                console.log('filter kts', filter(), r?.kts);
                r = { ...r, kts: filter() };
              } else {
                r = docoInsights;
              }
              return r;
              function filter() {
                return (r?.kts || []).filter(
                  ({ th, tg }) => !length || hasThemes(selectedThemes, th, customThemes, tg)
                );
              }
              function hasThemes(selectedThemes, th, customThemes, tg) {
                //Object.keys(selectedThemes);
                const cts = Object.keys(selectedThemes)
                  .filter(k => k / 1)
                  .map(k => customThemes[k]);
                return th?.some(t => selectedThemes[t]) || cts?.some(ct => hasKeywords(ct, tg));
                function hasKeywords({ selectedTags, andOr }, tg) {
                  let r = true;
                  const keys = Object.keys(selectedTags || {});
                  //todo: aliases
                  if (andOr === 'and') {
                    keys.forEach(tag => {
                      r = r && tg.includes(tag);
                    });
                  } else if (andOr === 'or') {
                    if (keys.length) {
                      r = tg.some(t => selectedTags[t]);
                    }
                  } else {
                    keys.forEach(tag => {
                      r = r && !tg.includes(tag);
                    });
                  }
                  return r;
                }
                //return Object.keys(selectedThemes).some(({ n }) => th?.includes(n));
                //return th?.filter(t => selectedThemes[t]).length === Object.keys(selectedThemes).length;
              }
              //return this.docoInsights;
            },
            hasModal(state, { newTheme, chartShown, watchlistShown }) {
              return newTheme || chartShown || watchlistShown;
            },
            allDids(
              state,
              { readingList, docoSmallCache, 'insightsNS/cheatsheet': cheatsheet, loadedPages, loadedDocuments }
            ) {
              const dids = (readingList || []).filter(did => !/^\|/.test(did));
              const insightsPageDids = Object.keys(cheatsheet?.documents) || [];
              // console.log('loadedPages', loadedPages);
              Object.keys(loadedPages || {})
                .concat(insightsPageDids)
                .concat(loadedDocuments || [])
                .forEach(did => {
                  if (!dids.includes(did)) {
                    dids.push(did);
                  }
                });
              // Object.keys(store.getters["insightsNS/cheatsheet"].documents)
              return dids;
            },
            zoomedPages({ zoomedPages }, { zoomedDoc, loadedPages }) {
              return (
                zoomedPages ||
                (zoomedDoc?.did &&
                  loadedPages[zoomedDoc.did] && { did: zoomedDoc.did, pgns: loadedPages[zoomedDoc.did] })
              );
            },
            zoomedInsights({ zoomedInsights }, { zoomedDoc, 'insightsNS/cheatsheet': cs }) {
              return (
                zoomedInsights ||
                (zoomedDoc?.did &&
                  cs?.documents[zoomedDoc.did] && {
                    did: zoomedDoc.did,
                    insights: cs?.documents[zoomedDoc.did]?.insights
                  })
              );
            },
            zoomed(state, { zoomedPages, zoomedInsights }) {
              return zoomedPages || zoomedInsights;
            },
            clipboardItems(state, { onClipboard }) {
              return Object.values(onClipboard)
                .filter(v => v)
                .sort((a, b) => a.index - b.index);
            },
            clipboardText(state, { clipboardItems }) {
              return (
                (clipboardItems && clipboardItems.length && clipboardItems.map(({ text }) => text).join('\n\n')) || ''
              );
            },
            clipboardHTML(state, { clipboardItems }) {
              return (
                (clipboardItems &&
                  clipboardItems.length &&
                  '<table>' + clipboardItems.map(({ text }) => `<tr><td>${ text }</td></tr>`).join('') + '</table>') ||
                ''
              );
            },
            groupBy() {
              return /[A-Z]{3}\-[0-9]{3}~/i.test(location.search);
            },
            currentCheatsheetJSON(
              {
                insightsNS: { loadedInsights }
              },
              {
                cheatsheetKeys,
                loadedPages: pages,
                playlist: videos,
                loadedDocuments: documents,
                loadedTweets: tweets,
                loadedFeedLps: feeds,
                loadedTitle: title,
                logo
              }
            ) {
              const insights = Object.keys(loadedInsights || {});
              const loaded = {
                pages,
                documents,
                videos,
                insights,
                tweets,
                feeds,
                title,
                logo
              };
              //todo: loadedInsights
              //loaded.insights = cheatsheet.insights;
              const current = {};
              if (title) {
                current.title = title;
              }
              if (logo) {
                current.logo = logo;
              }
              // console.log('cheatsheetKeys', cheatsheetKeys);
              cheatsheetKeys.forEach(key => {
                current[key] = loaded[key];
              });
              const pageEntries = Object.entries(current.pages || {});
              pageEntries.forEach(([did, value]) => {
                if (!value.length) {
                  delete current.pages[did];
                }
              });
              if (current.pages && !Object.entries(current.pages || {}).length) {
                delete current.pages;
              }
              return JSON.stringify(current);
            },
            dirty(state, { cheatsheetJSON, currentCheatsheetJSON }) {
              return cheatsheetJSON !== currentCheatsheetJSON;
            },
            OLDdirty(
              {
                insightsNS: { loadedInsights }
              },
              {
                cheatsheetJSON,
                cheatsheetKeys,
                cheatsheet,
                loadedPages: pages,
                playlist: videos,
                loadedDocuments: documents
              }
            ) {
              let r = false;
              // console.log('dirty: a', cheatsheetJSON);
              // console.log('dirty: b', stringify({ pages }));
              const insights = Object.keys(loadedInsights || {});
              const loaded = { pages, documents, videos, insights };
              //todo: loadedInsights
              //loaded.insights = cheatsheet.insights;
              const current = {};
              //console.log('cheatsheetKeys', cheatsheetKeys);
              cheatsheetKeys.forEach(key => {
                current[key] = loaded[key];
              });
              if (cheatsheetJSON !== stringify(current)) {
                r = true;
              }
              return r;
              function stringify(a) {
                return JSON.stringify(a);
              }
            },
            selectedTOPO(state, { allScenes, selectedTickers, tickersMap }) {
              return (
                allScenes &&
                allScenes
                  .filter(s => s.selected)
                  .concat(
                    Object.keys(selectedTickers || {}).map(key => ({ id: key, type: 'ticker', title: tickersMap[key] }))
                  )
              );
            },
            selected(state, { documents, selectedDocuments }) {
              return documents && documents.filter(s => selectedDocuments[s.pgn]);
            },
            sectors(state, { documents }) {
              return (
                documents &&
                Object.keys(
                  documents?.reduce(
                    (sectors, { scts }) => ({ ...sectors, ...scts.reduce((all, item) => ({ ...all, [item]: 0 }), {}) }),
                    {}
                  )
                )
              );
            },
            categories(state, { documents }) {
              return (
                documents &&
                Object.keys(
                  documents?.reduce(
                    (categories, { colls }) => ({
                      ...categories,
                      ...colls.reduce((all, item) => ({ ...all, [item]: 0 }), {})
                    }),
                    {}
                  )
                )
              );
            },
            NOTallTags(state, { documents }) {
              return (
                documents &&
                Object.keys(
                  documents?.reduce(
                    (tags, { tg }) => ({ ...tags, ...tg.reduce((all, item) => ({ ...all, [item]: 0 }), {}) }),
                    {}
                  )
                )
              );
            },
            allTags(state, { documents, selectedAllTags, filteredDocs }) {
              const r =
                documents &&
                Object.entries(
                  documents.reduce((tags, { tg }) => {
                    tg.forEach(tag => {
                      tags[tag] = tags[tag] || 0;
                      tags[tag]++;
                    });
                    return tags;
                  }, {})
                )
                  .filter(([tag, count]) => count > 1)
                  .filter((item, index) => index < 400)
                  .sort((a, b) => b[1] - a[1]);
              if (Object.entries(selectedAllTags).length) {
                // zero out dead ends
                const filteredTags = filteredDocs.reduce((tags, { tg }) => {
                  tg.forEach(tag => {
                    tags[tag] = tags[tag] || 0;
                    tags[tag]++;
                  });
                  return tags;
                }, {});
                r.forEach(([tag], i) => (r[i] = [tag, filteredTags[tag] || 0]));
              }
              return r;
            },
            cookieDomain() {
              return cookieDomain();
            },
            engagement(state) {
              return [...(state.interestingness || []), ...(state.visuality || [])];
            },
            default_engagement(state, { default_interestingness, default_visuality }) {
              return [...(default_interestingness || []), ...(default_visuality || [])];
            },
            folderAgeQuantiles(state, { folderAge = [] }) {
              const [min, max] = folderAge.map(v => v + 1);
              return range(min, max);
            },
            sentimentQuantiles(state, { sentiment = [] }) {
              const [min, max] = sentiment.map(v => v + 1);
              return range(min, max);
            },
            interestingnessQuantiles(state, { interestingness = [] }) {
              const [min, max] = interestingness.map(v => v + 1);
              return range(min, max);
            },
            visualityQuantiles(state, { visuality = [] }) {
              const [min, max] = visuality.map(v => v + 1);
              return range(min, max);
            },
            allScenes(state, { scenes, persistedSelection }) {
              return [...(scenes || []), ...(persistedSelection || [])];
            },
            themes(
              state,
              {
                documents,
                folderList,
                /* docoThemes,*/ folderThemes,
                roboThemes,
                watchlistThemes,
                roboWeaveShown,
                watchlistShown,
                doco,
                robo,
                watchlist
              }
            ) {
              let r; // = state.themes;
              if (watchlistShown || (Object.keys(watchlist).length && !robo && !folderList && !doco)) {
                r = watchlistThemes;
              } else if (roboWeaveShown || (!folderList && !doco)) {
                r = roboThemes;
              } else if (folderList) {
                r = folderThemes;
              } else if (!folderList && !robo && !watchlist) {
                const inDocs =
                  documents &&
                  Object.entries(
                    documents.reduce((themes, { th: theme }) => {
                      theme?.forEach(theme => {
                        themes[theme] = themes[theme] || 0;
                        themes[theme]++;
                      });
                      return themes;
                    }, {})
                  ).reduce((themes, [theme, count]) => {
                    if (count > 0) {
                      themes[theme] = count;
                    }
                    return themes;
                  }, {});
                // return state.themes?.filter(({ t }) => inDocs[t])
                //   .sort((a, b) => inDocs[b.t] - inDocs[a.t])
                //   .map(theme => ({ ...theme, count: inDocs[theme.t] }))
                //   .filter((theme, i) => i <= 40);
                r =
                  Object.values(state.themes || {})
                    .filter(({ n }) => !inDocs || inDocs[n])
                    .sort((a, b) => (inDocs && inDocs[b.n] - inDocs[a.n]) || 0)
                    .map(theme => (inDocs && { ...theme, count: inDocs[theme.n], c: inDocs[theme.n] }) || theme)
                    //.filter((theme, i) => i < 40)
                    .reduce((map, item) => {
                      map[item.n || item.th?.n] = item;
                      return map;
                    }, {}) || null;
              }
              return r || state.themes;
            },
            tags(state, { documents }) {
              return (
                documents &&
                Object.entries(
                  documents.reduce((tags, { tg }) => {
                    tg.forEach(tag => {
                      tags[tag] = tags[tag] || 0;
                      tags[tag]++;
                    });
                    return tags;
                  }, {})
                  // Object.entries(scenes.reduce(collectUnique, {}))
                  //   .filter(([, scenes]) => scenes.length > 7)
                  //   .filter(([tag]) => /^[^\s\:]+$/.test(tag))
                  //   .reduce(entriesToObject, {})
                ).reduce((tags, [tag, count]) => {
                  if (count > 7) {
                    tags[tag] = count;
                  }
                  return tags;
                }, {})
              );
            },
            tagsTOPO(state, { scenes }) {
              return (
                scenes &&
                Object.entries(scenes.reduce(collectUnique, {}))
                  .filter(([, scenes]) => scenes.length > 7)
                  .filter(([tag]) => /^[^\s\:]+$/.test(tag))
                  .reduce(entriesToObject, {})
              );
              function collectUnique(all, s) {
                const tags = s.tg.filter(tag => /^[^\s\:]+$/.test(tag));
                const count = s.tg.length;
                tags.forEach((tag, index) => {
                  all[tag] = all[tag] || [];
                  s.tagRank = s.tagRank || {};
                  s.tagRank[tag] = (count - index) / count;
                  all[tag].push(s);
                });
                return all;
              }
            },
            tmpItems(state, { selectedThemes, customThemes, folderList, skimmerSort }) {
              // const { selectedThemes, customThemes, folderList, skimmerSort } = this;
              const selectedThemesKeys = Object.keys(selectedThemes || {});
              const { length } = selectedThemesKeys;
              return filter();
              function filter() {
                // console.log('items filter 2', (Object.entries(folderList) || []).filter(([did, { th, tg }]) => !length || hasThemes(selectedThemes, th, customThemes, tg))
                //     .reduce((all, [did, doc]) => {
                //       all[did] = doc;
                //       return all;
                //     }, {}));
                //return (Object.entries(folderList) || []).filter(([did, { th, tg }]) => !length || hasThemes(selectedThemes, th, customThemes, tg))
                const sorters = (length && {
                  Weight: (a, b) => totalWeights(b[1], 'w') - totalWeights(a[1], 'w'),
                  vis: (a, b) => totalWeights(b[1], 'v') - totalWeights(a[1], 'v'),
                  age: (a, b) => b[1].ds?.dpa - a[1].ds?.dpa,
                  pos: (a, b) => totalWeights(b[1], 'p') - totalWeights(a[1], 'p'),
                  neg: (a, b) => totalWeights(b[1], 'n') - totalWeights(a[1], 'n')
                }) || {
                  Weight: (a, b) => b[1].w - a[1].w,
                  vis: (a, b) => b[1].v - a[1].v,
                  age: (a, b) => b[1].ds?.dpa - a[1].ds?.dpa,
                  pos: (a, b) => b[1].p - a[1].p,
                  neg: (a, b) => b[1].n - a[1].n
                };
                return (Object.entries(folderList) || [])
                  .filter(([did, { th, tg }]) => {
                    //console.log('did', did, hasThemes(selectedThemes, th, customThemes, tg));
                    return !length || hasThemes(selectedThemes, th, customThemes, tg);
                  })
                  .sort(sorters[skimmerSort])
                  .reduce((all, [did, doc]) => {
                    all[did] = doc;
                    return all;
                  }, {});
              }
              function totalWeights(item, prop) {
                return selectedThemesKeys.reduce((total, theme) => total + item.themes[theme]?.[prop] || 0, 0);
              }
              function hasThemes(selectedThemes, th, customThemes, tg) {
                //Object.keys(selectedThemes);
                const cts = Object.keys(selectedThemes || {})
                  .filter(k => k / 1)
                  .map(k => customThemes[k]);
                //console.log(4232, cts, th?.join(', '), th?.some(t => selectedThemes[(t || '').replace(/\s/, '-')]));
                //console.log(4232, cts, Object.keys(selectedThemes || {}).join(', '), '\n\n', th?.join(', '), th?.some(t => selectedThemes[t]));
                return th?.some(n => selectedThemes[n]) || cts?.some(ct => hasKeywords(ct, tg));
                function hasKeywords({ selectedTags, andOr }, tg) {
                  let r = true;
                  const keys = Object.keys(selectedTags || {});
                  //console.log('hasKeywords', keys, tg?.join(', '));
                  //todo: aliases
                  if (andOr === 'and') {
                    keys.forEach(tag => {
                      r = r && tg?.includes(tag);
                    });
                  } else if (andOr === 'or') {
                    if (keys.length) {
                      r = tg?.some(n => selectedTags[n]);
                    }
                  } else {
                    keys.forEach(tag => {
                      r = r && !tg?.includes(tag);
                    });
                  }
                  return r;
                }
                //return Object.keys(selectedThemes).some(({ n }) => th?.includes(n));
                //return th?.filter(t => selectedThemes[t]).length === Object.keys(selectedThemes).length;
              }
            },
            tagCounts(state, { tags }) {
              tags = tags || {
                Entrepreneurship: 14,
                Nanotechnology: 12,
                Robotics: 12,
                Uber: 31,
                Xiaomi: 8,
                Airbnb: 16,
                California: 207,
                Android: 83,
                IOS: 56,
                Canada: 63,
                Privacy: 8,
                Google: 127,
                YouTube: 14,
                Amazon: 43,
                Facebook: 56,
                China: 57,
                Asia: 43,
                Shanghai: 10,
                Beijing: 14,
                Taiwan: 17,
                Boston: 19,
                NASDAQ: 25,
                Instagram: 12,
                WhatsApp: 8,
                Germany: 47,
                Europe: 95,
                Finance: 8,
                Switzerland: 12,
                London: 35,
                Ireland: 11,
                Chicago: 17,
                Cryptocurrency: 16,
                Bitcoin: 14,
                Blockchain: 8,
                Law: 8,
                Linux: 24,
                France: 43,
                Government: 10,
                India: 58,
                Finland: 11,
                Sweden: 13,
                Russia: 25,
                Israel: 17,
                Telecommunication: 9,
                Paris: 13,
                Education: 8,
                Marketing: 10,
                LinkedIn: 10,
                Snapchat: 8,
                Pinterest: 10,
                Twitter: 32,
                Biotechnology: 14,
                IBM: 26,
                Intel: 31,
                Toronto: 10,
                SpaceX: 10,
                PayPal: 23,
                EBay: 31,
                Netherlands: 15,
                Mexico: 15,
                Australia: 35,
                Spain: 27,
                Italy: 12,
                Japan: 31,
                Dropbox: 9,
                'Salesforce.com': 8,
                Africa: 21,
                Smartwatch: 10,
                IPad: 12,
                'E-commerce': 29,
                IPhone: 14,
                Agriculture: 11,
                Tokyo: 15,
                Seattle: 21,
                Microsoft: 89,
                Nvidia: 10,
                Semiconductor: 11,
                Stripe: 8,
                Brazil: 22,
                Netflix: 12,
                Philippines: 15,
                Singapore: 18,
                'E-book': 9,
                MacOS: 24,
                Berlin: 10,
                Sony: 10,
                Thailand: 9,
                Indonesia: 15,
                Poland: 8,
                Ukraine: 9,
                Spotify: 8,
                LGBT: 10,
                Tencent: 11,
                'Yahoo!': 22,
                Qualcomm: 8,
                Melbourne: 8,
                Malaysia: 10,
                Bangalore: 11,
                GV: 9,
                Chile: 8,
                Baidu: 9,
                Vietnam: 10,
                Zynga: 8
              };
              return (
                tags &&
                Object.entries(tags)
                  .map(([tag, scenes]) => [tag, scenes.length])
                  .reduce(entriesToObject, {}) &&
                tags
              );
            },
            filteredByTag(state, { tags, selectedTags }) {
              const [firstTag, ...otherTags] = Object.keys(selectedTags || {});
              return (
                firstTag &&
                tags[firstTag]
                  .sort((a, b) => {
                    const { tagRank: bt } = b;
                    const { tagRank: at } = a;
                    return bt[firstTag] - at[firstTag] || b.tg.length - a.tg.length;
                  })
                  .filter(scene => {
                    return (
                      !otherTags ||
                      !otherTags.length ||
                      otherTags.filter(tag => scene.tg.indexOf(tag) > -1).length === otherTags.length
                    );
                  })
              );
            },
            selectedTagsLength(state, { selectedTags }) {
              return (selectedTags && Object.keys(selectedTags).length) || undefined;
            },
            docoInsights({ docoInsights }, { selectedThemes, customThemes }) {
              //todo: handle tags
              const length = Object.keys(selectedThemes).length;
              return (
                (docoInsights && {
                  ...docoInsights,
                  kts: docoInsights.kts?.filter(
                    ({ th, tg }) => !length || hasThemes(selectedThemes, th, customThemes, tg)
                  )
                }) ||
                {}
              );
            },
            tocSort({ tocSort, selectedThemes }) {
              return (Object.keys(selectedThemes).length && tocSort) || null;
            },
            filteredWatchlistThemes(
              { watchListThemes: allThemes },
              {
                watchlistThemesForPicker,
                watchlistThemesParentFilter: filter,
                watchlistThemes: themes,
                watchlistThemesFilter,
                watchlistThemeWeightFilter
              }
            ) {
              return (
                (filter && [
                  themes[filter],
                  ...(watchlistThemesForPicker[filter]?.cth?.map(({ n }) => themes?.[n]).filter(th => th) || [])
                ]) ||
                Object.values(watchlistThemesFilter && themes || watchlistThemesForPicker || {})
              )
                .filter(({ n, t, k }) => {
                  // could add k to search text but since they are not show i think that there would be a lot of confusion
                  const searchText = `${ n }|${ t }`;
                  const aliases = k?.join('|');
                  return !watchlistThemesFilter || watchlistThemesFilter.split(/\s+/).every(testWord);
                  function testWord(word) {
                    const tester = new RegExp(escapeRegExp(word), 'i');
                    return tester.test(searchText) || new RegExp(escapeRegExpAndBound(word), 'i').test(aliases);
                  }
                  function escapeRegExpAndBound(s) {
                    return `\\b${ escapeRegExp(s) }\\b`; // $& means the whole matched string
                  }
                  function escapeRegExp(s) {
                    return `${ s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }`; // $& means the whole matched string
                  }
                })
                //.sort((a, b) => b.cr - a.cr)
                .sort((a, b) => dynamicCr(b) - dynamicCr(a))
                .filter(
                  th => {
                    // const { cr } = th;
                    const cr = dynamicCr(th);
                    return (watchlistThemeWeightFilter?.min || 0) <= cr && cr <= (watchlistThemeWeightFilter?.max || 100);
                  }
                )
                .filter((item, i) => i < 400);
              function dynamicCr(theme) {
                let r = theme.cr;
                if (filter) {
                  if (theme.cth) {
                    r = 100;
                  } else {
                    const { cth } = themes[filter] || {};
                    if (cth && theme.index > -1) {
                      r = cth.find(({ n }) => n === theme.n)?.cr || r;
                      // r = cth[theme.index]?.cr || r;
                    }
                  }
                }
                return r;
              }
            },
            themesWithAliases(state, { themes, uniqueRoboReportWordsMap }) {
              //todo: handle custom themes
              return Array.from(
                new Set(
                  Object.entries(themes || {})
                    .filter(([key]) => !(key / 1))
                    .map(([key, { k }]) => [key].concat(k))
                    .reduce((all, item) => {
                      return all.concat(item);
                    }, [])
                )
              ).filter(k => k.split(' ').some(w => uniqueRoboReportWordsMap[w]));
            },
            watchlistSelectedThemesWithAliases(state, { selectedWatchlistThemes, themes, uniqueRoboReportWordsMap }) {
              //todo: handle custom themes
              return Array.from(
                new Set(
                  Object.entries(themes || {})
                    .filter(([key]) => selectedWatchlistThemes[key])
                    .filter(([key]) => !(key / 1))
                    .map(([key, { k, t }]) => [(t || key).toLowerCase()].concat(k))
                    .reduce((all, item) => {
                      //console.log('watchlistSelectedThemesWithAliases', all, item);
                      return all.concat(item);
                    }, [])
                )
              ).filter(k => k.split(/\W+/).some(w => uniqueRoboReportWordsMap[w.toLowerCase()]));
            },
            uniqueRoboReportWordsMap(state, { roboReport }) {
              return (
                roboReport?.insights?.length &&
                Array.from(
                  new Set(
                    roboReport.insights
                      .map(({ k }) => k)
                      .join(' ')
                      .toLowerCase()
                      .split(/\W+/)
                  )
                )
                  .filter(w => w.replace(/[\s\W]/g, '').length)
                  .reduce((all, w) => {
                    all[w] = true;
                    return all;
                  }, {})
              );
            },
            selectedThemesWithAliases(state, { themes, selectedThemes }) {
              //todo: handle custom themes
              return Object.entries(themes || {})
                .filter(([key]) => selectedThemes[key])
                .filter(([key]) => !(key / 1))
                .map(([key, { k }]) => [key].concat(k))
                .reduce((all, item) => {
                  return all.concat(item);
                }, []);
            },
            filteredDocs(
              state,
              {
                documents,
                selectedSectors = [],
                selectedCategories = [],
                selectedAllTags = {},
                sentimentQuantiles,
                visualityQuantiles,
                interestingnessQuantiles,
                selectedThemes,
                andOr,
                customThemes
              }
            ) {
              const sectors = selectedSectors.reduce((all, item) => ({ ...all, [item]: 1 }), {});
              const categories = selectedCategories.reduce((all, item) => ({ ...all, [item]: 1 }), {});
              // const tags = selectedAllTags;//.reduce((all, item) => ({ ...all, [item]: 1 }), {});
              let r;
              if (documents) {
                r = Array.from(documents, d => ({
                  ...d,
                  sectors: d.scts.reduce((sectors, a) => ({ ...sectors, [a]: 1 }), {}),
                  tags: d.tg.reduce((tags, a) => ({ ...tags, [a]: 1 }), {}),
                  categories: d.colls.reduce((categories, a) => ({ ...categories, [a]: 1 }), {})
                }));
                Object.keys(sectors).forEach(sector => (r = r.filter(({ sectors }) => sectors[sector])));
                Object.keys(categories).forEach(category => (r = r.filter(({ categories }) => categories[category])));
                //Object.keys(selectedAllTags).forEach(tag => r = r.filter(({ tags }) => tags[tag]));
                if (andOr === 'and') {
                  Object.keys(selectedAllTags).forEach(tag => (r = r.filter(({ tags }) => tags[tag])));
                } else if (andOr === 'or') {
                  if (Object.keys(selectedAllTags || {}).length) {
                    r = r.filter(({ tg }) => tg.some(t => selectedAllTags[t]));
                  }
                } else {
                  Object.keys(selectedAllTags).forEach(tag => (r = r.filter(({ tags }) => !tags[tag])));
                }
                if (Object.keys(selectedThemes).length) {
                  r = r.filter(({ th, tg }) => hasThemes(selectedThemes, th, customThemes, tg));
                }
                r = r.filter(
                  ({ sentq, visq, relq }) =>
                    sentimentQuantiles.includes(sentq) &&
                    visualityQuantiles.includes(visq) &&
                    interestingnessQuantiles.includes(relq)
                );
              }
              return r;
            },
            filteredDocsWithInsights(state, { filteredDocs, selectedDocuments }) {
              return filteredDocs
                ?.filter(({ kt: { length }, pgn }) => length && selectedDocuments[pgn])
                .sort((a, b) => b.ktiw - a.ktiw);
            },
            insightTags(state, { filteredDocsWithInsights }) {
              return filteredDocsWithInsights?.reduce((all, { kti }) => {
                kti.forEach(({ tg }) => {
                  tg.forEach(tag => {
                    all[tag] = all[tag] || 0;
                    all[tag]++;
                  });
                });
                return all;
              }, {});
            },
            insightTagsFiltered(state, { insightTags }) {
              let r = aggregate();
              if (Object.keys(r).length < 20) {
                r = aggregate(0);
              }
              return r;
              function aggregate(thresold = 5) {
                return Object.entries(insightTags || {}).reduce((all, [tag, count]) => {
                  if (count > thresold) {
                    all[tag] = (count < 40 && count) || 40;
                  }
                  return all;
                }, {});
              }
            },
            framed() {
              try {
                return window.self !== window.top;
              } catch (e) {
                return true;
              }
            },
            tweetBase() {
              return awsBase + 'tweets/';
            },
            videoBase() {
              // return 'https://topoqa.azurewebsites.net/api/topoqa/videosqa'; // + 'videos/';
              return 'https://d1l6gufwe1p5x2.cloudfront.net/api/topoqa/videosqa'; // + 'videos/';
            },
            someVideos(state, { selected, videos }) {
              return selected && videos?.length;
            },
            someTweets(state, { selected, tweets }) {
              return selected && tweets?.length;
            },
            filteredTweets(state, { tweets }) {
              return tweets;
            },
            someDocuments(state, { selected, documents }) {
              return selected && documents?.length;
            },
            filteredDocuments(state, { documents }) {
              return documents;
            },
            currentVideoIndex(state, { videosForCurrentContext: playlist, currentVideo }) {
              const r = (playlist && currentVideo !== null && playlist.map(v => v.id).indexOf(currentVideo.id));
              return r < 0 ? null: r;
            },
            nextVideo(state, { videosForCurrentContext: playlist, currentVideoIndex }) {
              const [next] = [...(playlist || [])].splice(currentVideoIndex + 1).filter(v => v.ce || v.sc);
              return next;
            },
            prevVideo(state, { videosForCurrentContext: playlist, currentVideoIndex }) {
              return [...(playlist || [])]
                .splice(0, currentVideoIndex)
                .filter(v => v.ce || v.sc)
                .pop();
            },
            filteredVideos(state, { videos }) {
              return videos;
            },
            videosForCurrentContext(state, { playlist, watchlistShown, roboWeaveShown, trendingVideos, watchlistTrendingVideos, engageShown, engagePlaylist }) {
              return engageShown && engagePlaylist || watchlistShown && watchlistTrendingVideos || roboWeaveShown && trendingVideos || playlist;
            },
            searchResults(state, { query, topos, filteredByTag, scenes, tickers }) {
              const value = (query || '').trim();
              const { entries = [] } = topos || {};
              const items = entries.concat(filteredByTag || scenes).concat(tickers);
              const filter = value.length !== 0;
              let filtered = []; // group;
              const matches = {
                best: [],
                startsWith: [],
                wordStartsWith: [],
                wild: []
              };
              const regs = value
                .replace(/^\s+|\s+$/g, '')
                .split(/\s+/)
                .map(value => {
                  const wild = new RegExp(value, 'i');
                  return {
                    wild: wild,
                    word: new RegExp('\\b' + wild.source, 'i'),
                    start: new RegExp('^' + wild.source, 'i')
                  };
                });
              if (filter) {
                items.forEach(result => {
                  let m;
                  const match = (m = {
                    startsWith: 0,
                    wordStartsWith: 0,
                    wild: 0,
                    count: 0
                  });
                  regs.forEach((reg, i) => {
                    if (m.count === i) {
                      const s = result.search;
                      if (
                        (reg.start.test(s) && ++m.startsWith) ||
                        (reg.word.test(s) && ++m.wordStartsWith) ||
                        (reg.wild.test(s) && ++m.wild)
                      ) {
                        m.count++;
                      }
                    }
                  });
                  if (match.count === regs.length) {
                    if (match.startsWith) {
                      matches[match.wordStartsWith === regs.length - 1 ? 'best' : 'startsWith'].push(result);
                    } else {
                      matches[match.wordStartsWith === regs.length ? 'wordStartsWith' : 'wild'].push(result);
                    }
                  }
                });
                filtered = matches.best.concat(matches.startsWith.concat(matches.wordStartsWith, matches.wild));
              }
              const max = 18;
              return ((filtered.length && filtered) || items).slice(0, max).map(item => ({
                ...item,
                type: item?.type || 'on-page',
                text: (item?.url || '').replace(/^.+?\?/, '')
              }));
              // setTimeout(() => {
              //report('search', 'query', value);
              // }, 20);
              // return filtered;
              // todo: setTimeout this
              // var first = target.querySelector('.result');
              // if (first) {
              //   move(first);
              // }
              // console.log(new Date() - start, 'ms');
            }
          }
        },
        props
      )
    );
  }
  let customThemesTimer;
  window.fetchMedia = fetchMedia;
  Vue.prototype.store = store.instance;
  window.store = store.instance;
  window.g = window.store.getters;
  store.instance.$localforage = Vue.$localforage;
  return store.instance;
  function getAu() {
    const au = Vue.cookie.get('au');
    return au && JSON.parse(atob(au) || {});
  }
  function engage() {
    return (/[\?\;\&]eg\=([^\;]+)/.exec(window.location.search || '') || [])[1] || '';
  }
  function cookieDomain() {
    return location.hostname.replace(/.*(\.[^\.]+\.[^\.]+)/, '$1');
  }
  // function removeEmptyThemes(customThemes = {}) {
  //   const r = {};
  //   Object.entries(customThemes).forEach(([key, ct]) => {
  //     console.log('removeEmptyThemes 1', ct.id, ct.n, ct);
  //     if (ct.n) {
  //       console.log('have n', ct.n);
  //       r[key] = ct;
  //     }
  //   });
  //   return r;
  // }
  function saveCustomThemes({ customThemes }) {
    clearTimeout(customThemesTimer);
    customThemesTimer = setTimeout(() => Vue.$localforage.setItem('customThemes', customThemes), 750);
  }
  function hasThemes(selectedThemes, th, customThemes, tg) {
    //Object.keys(selectedThemes);
    const cts = Object.keys(selectedThemes)
      .filter(k => k / 1)
      .map(k => customThemes[k]);
    return th?.some(t => selectedThemes[t]) || cts?.some(ct => hasKeywords(ct, tg));
    function hasKeywords({ selectedTags, andOr }, tg) {
      let r = true;
      const keys = Object.keys(selectedTags || {});
      //todo: aliases
      if (andOr === 'and') {
        keys.forEach(tag => {
          r = r && tg.includes(tag);
        });
      } else if (andOr === 'or') {
        if (keys.length) {
          r = tg.some(t => selectedTags[t]);
        }
      } else {
        keys.forEach(tag => {
          r = r && !tg.includes(tag);
        });
      }
      return r;
    }
    //return Object.keys(selectedThemes).some(({ n }) => th?.includes(n));
    //return th?.filter(t => selectedThemes[t]).length === Object.keys(selectedThemes).length;
  }
  async function fetchMedia({ getters, dispatch }, type = 'video', newTags) {
    const plural = type + 's';
    const namespace = plural + 'NS/';
    const { selected } = getters;
    if (selected?.length) {
      dispatch('addLoader', 'fetchMedia');
      const getNS = prop => getters[namespace + prop];
      const mappedType = { document: 'doc' }[type] || type;
      const body = {
        keywords: null,
        pipSupport: true, // return pip-able items
        count: 201, // limit
        skip: 0, // offset
        topics: selected.map(({ type, topo, id }) => (type === 'ticker' && '$' + id) || `${ topo.title }-${ id }`),
        topicsMode: 'any',
        strictTopics: true,
        subqueries: [
          {
            mustInclude: null,
            mustExclude: null,
            tags: Object.keys(getNS('selectedTags') || {}),
            tagMode: 'all', // any or all
            wkLocations: null, // wikipedia locations
            wkLocationsMode: 'any', // any or all
            cashTags: null,
            cashTagsMode: 'any',
            weaves: getNS('selectedSectors').map(c => c.value),
            weavesMode: 'any',
            collections: getNS('selectedCategories').map(c => c.value),
            collectionsMode: 'any',
            channelIds: Object.keys(getNS('selectedSourceIds')),
            durationQuantiles: getNS('durationQuantiles'),
            sentimentQuantiles: getNS('sentimentQuantiles'),
            interestingnessQuantiles: getNS('interestingnessQuantiles'),
            visualQuantiles: getNS('visualityQuantiles'),
            subscriberCountQuantiles: getNS('subscriberCountQuantiles'),
            publishedAtQuantiles: getNS('publishedAtQuantiles')
          } /*,
            {
              mi: null,
              me: null,
              tg: null,
              tgmode: 'any',
              wkl: null,
              wklmode: 'any',
              csh: null,
              cshmode: 'any',
              wv: null,
              wvmode: 'any',
              col: null,
              colmode: 'any',
              cid: null,
              dq: null,
              sq: [
                1,
                2
              ],
              subq: null,
              pa: null
            }*/
        ]
      };
      if (plural === 'documents') {
        body.subqueries[0].documentTypes = getNS('selectedTypes').map(c => c.value);
      }
      const response = await fetch(`https://topoqa.azurewebsites.net/api/topoqa/${ mappedType }s`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify(body)
      });
      const { results, facets } = await response.json();
      const [facet = {}] = facets;
      const { tags, collections, weaves: sectors, channelInfo, userInfo, sourceUserInfo, type: types } = facet;
      dispatch(plural, results);
      const sources = (channelInfo || userInfo || sourceUserInfo || []).map(c => ({
        ...c,
        info: info(JSON.parse(c.value))
      }));
      if (newTags) {
        nsDispatch(
          'tags',
          tags?.sort((a, b) => b.count - a.count).reduce((all, { value, count }) => ({ ...all, [value]: count }), {})
        );
        nsDispatch('categories', collections);
        nsDispatch('sectors', sectors);
        nsDispatch('types', types);
        nsDispatch('sourceIds', sources);
      } else {
        //dispatch('updateVideoTags', tags);
        nsDispatch('updateTags', tags);
        nsDispatch('updateSourceIds', sources);
        // todo: updateVideoCategories
        //dispatch('updateVideoCategories', collections);
      }
    } else {
      dispatch(plural, null);
      nsDispatch('tags', {});
      dispatch(plural + 'Shown', false);
      if (newTags) {
        nsDispatch('categories', []);
        nsDispatch('sectors', []);
        nsDispatch('types', []);
        nsDispatch('sourceIds', []);
      }
    }
    dispatch('removeLoader');
    function nsDispatch(action, value) {
      return dispatch(namespace + action, value);
    }
    function info({ c: id, t: name, u: url, s }) {
      return { id: id || s, name, url };
    }
  }
  function entriesToObject(all, [tag, count]) {
    all[tag] = count;
    return all;
  }
  function initialWiderInsights() {
    const wi = Vue.cookie.get('widerInsights');
    return wi === null || wi === 'true';
  }
}

// const frame = document.createElement('iframe');
// window.loadDoc = function (element, url) {
//   console.log('loadDoc', url, element);
//   element = loadDoc.element = loadDoc.element || element;
//   // console.log('loadDoc', index || 99);
//   // var cover = section && section.querySelector('.cover');
//   if (element && frame && url) {
//     console.log('loadDoc with frame', url, element);
//     // if (!/local/.test(location.href)) {
//     if (true || !/jsfoo/.test(location.href)) {
//       frame.setAttribute('height', 650);
//       console.log('==============doc viewer mid2', `//docs.google.com/viewer?url=${ url }&embedded=true`);
//       frame.setAttribute('style', 'width: 100%; border: none;');
//       frame.setAttribute('src', `//docs.google.com/viewer?url=${ url }&embedded=true`);
//       console.log('src set');
//       element.appendChild(frame);
//     }
//   }
// };

// function filteredDocs(documents, { sectors = {}, categories = {}, tags = {} }) {
//   let r = Array.from(documents, d => ({
//     ...d,
//     sectors: d.scts.reduce((sectors, a) => ({ ...sectors, [a]: 1 }), {}),
//     tags: d.tg.reduce((tags, a) => ({ ...tags, [a]: 1 }), {}),
//     categories: d.colls.reduce((categories, a) => ({ ...categories, [a]: 1 }), {}) }));
//   Object.keys(sectors).forEach(sector => r = r.filter(({ sectors }) => sectors[sector]));
//   Object.keys(categories).forEach(category => r = r.filter(({ categories }) => categories[category]));
//   Object.keys(tags).forEach(tag => r = r.filter(({ tags }) => tags[tag]));
//   return r;
// }

//(d => [filter(d, { sectors: {}, categories: { Business: 1 }, tags: {} })/*, sectors(d), categories(d), tags(d)*/])(store.getters.documents);
